export const locale = {
  GENERAL: {
    NO_DATA: '尚无资料',
    CANCEL: '取消',
    CONFIRM: '确认',
    EDIT: '编辑',
    ADD: '新增',
    COPY: '复制',
    COPIED: '已复制',
    DELETE: '删除',
    SAVE: '储存',
    SHOW_CONTENT: '展开',
    HIDE_CONTENT: '收合',
    AUTH: '无权查看此对象内容',
    DAY: '天',
    ALL: '全部',
    RELEASE: '发布',
    APPLY: '套用',
    RESTART_EDITING: '重启编辑',
    CHANGE_OWNER: '变更拥有者',
    CHANGE_OWNER_2: '变更客服人员',
    CHANGE_OWNER_3: '变更作者',
    ADD_DEAL: '新增商机',
    ADD_Case: '新增案件',
    CLOSE: '关闭',
    PIN: '钉选',
    FIELDHISTORY: '变更纪录',
    NO_FIELDHISTORY: '尚无变更纪录',
    NO_EMAIL: '尚无电邮',
    NO_SMS: '尚无简讯',
    ACTIVE: '执行',
    LOGOUT: '注销',
    SUCCESS: '成功',
    DASHBOARD: '仪表板',
    DATASHEET: '数据表',
    NEXT: '下一步',
    PRE: '上一步',
    NONE: '无',
    MAIL: '电子邮件',
    LAST_NAME: '姓氏',
    FIRST_NAME: '名称',
    SHORTCUTS: '快捷方式',
    STATUS: '状态设定',
    REFRESH: '更新',
    SETTING_BTN: '数据表&筛选',
    PRODUCT: '产品',
    ACTIVITY: '活动',
    TO: '收件者',
    CC: '副本',
    SENDER: '发件人',
    INCOMING: "收件",
    OUTGOING: "寄件",
    RELOAD: '重整',
    LOGOUT_MSG: "您确定要注销吗?",
    SEARCH: "搜寻",
    UPDATE: "更新",
    SELECTALL: "全选",
    KEEP_OLD_PASSWORD: "沿用旧密码",
    DONT_APPLY: "不套用",
    SAVEANDRUN: "储存并生成",
  },
  //------- Log in
  LOGIN: {
    MICROSOFT: '使用Microsoft帐号登录',
    BACK_TO_LOGIN: '切换回账号密码登录',
    MICROSOFT_LOGIN_TITLE: 'Microsoft帐户登录',
    REFRESH: '重新整理',
    HINT_1: '请先确认已登录微软账户。',
    HINT_2: '再按“重新整理”即可开始使用',
    ACCOUNT: '账号',
    PWD: '密码',
    TENANT: '租户名称',
    TRY: '免费试用',
    LOGIN: '登入',
    LOGIN_2: '登入 UpDay',
    LOGIN_UPCHAT: '登入 UpChat',
    LOGIN_UPGPT: '登入 UpGPT',
    GET_VALI_CODE: '取验证码',
    LOGIN_VALI_CODE: '验证码',
    DESCRIPTION: '一站式轻松管理所有客户信息',
    PASSWORD: '忘记密码',
    ERROR: '请输入账号密码',
    ERROR_2: '请输入租户名称',
    ERROR_3: '账号或密码错误，请重试',
    ERROR_3_VALI_CODE: '账号或密码或验证码错误，请重试',
    ERROR_4: '请输入账号取得验证码',
    ERROR_5: '登录信息错误',
    SENT_VALI_CODE: '验证码已发送至您的电邮',
    LOGIN_VAL_ERROR: '无法发送验证码。详情请联系系统管理员',
  },
  UPGPT_LOGIN: {
    TITLE: '欢迎回来！',
    SUBTITLE_1: '准备开始',
    SUBTITLE_2: '与UpGPT的精彩对话？',
    LOGIN: '登入',
    DISCLAIMER: '免责声明',
    TERMSOFUSE: '使用条款',
    PRIVACYPOLICY: '隐私政策',
    CHANGE_PASSWORD_ALERT: '为了确保您的帐户安全，我们建议您变更初始密码。',
  },
  FORGET_PASSWORD: {
    TITLE: '忘记密码',
    TENANT: '租户名称',
    ACCOUNT: '账号',
    MAIL: 'E-Mail',
    ERROR: '输入数据有误，请确认后再试一次。',
    AIRGAPPED: '请联系您的管理员以重置密码。',
  },
  TRY_IT_FREE: {
    TITLE: '免费试用 UpDay 14天',
    FIRST_NAME: '*名称',
    LAST_NAME: '*姓氏',
    ORG_NAME: '公司名称',
    ROLE: '职称',
    PHONE: '联络电话',
    MESSAGE: '信息',
    MESSAGE_2: '谢谢您申请，我们将尽快与您联系',
    ERROR: '请输入有效的电子邮件',
  },
  //------- Bower Title
  Bower_Title: {
    UPCHAT: 'Upday CIC - 客户互动中心',
    Oppty_Dashboard: '商机案件仪表板 - UpDay',
    Case_Dashboard: '客服案件仪表板 - UpDay',
    Activity: '活动',
    Oppty_List: '商机总览',
    Oppty: '商机',
    Deal: '商机',
    Contacts_List: '联络人总览',
    Contact: '联络人',
    Company_List: '公司总览',
    Company: '公司',
    Account: '公司',
    Campaign_List: '活动总览 - UpDay',
    Campaign: '营销活动',
    Segment_List: '分群总览 - UpDay',
    Segment: '分群',
    Case_List: '案件总览',
    Case: '案件',
    Order_List: '订单总览',
    WIADVANCE_Order_List: '合约总览',
    Order: '订单',
    WIADVANCE_Order: '合约',
    KnowledgeArticle_List: '知识库文章总览 - UpDay',
    KnowledgeArticle: '知识库文章',
    Setting: '设定 - UpDay',
    Login: '登入UpDay',
    LoginUpGPT: '登入UpGPT',
    ResetPasswordogin: '重设密码 - UpDay',
    PermissionError: '权限不足 - UpDay',
    PermissionError_PAGE: '无权查看此对象内容',
    Portal_PermissionError_PAGE: '您目前尚无 UpGPT Portal 的使用权限，请联络系统管理员以取得权限。',
    PageNotFoundError: '此对象不存在 - UpDay',
    PageNotFoundError_PAGE: '此对象不存在，请返回上一页。',
  },
  //---------Rule
  RULE: {
    RULE_R_NUM: '此字段为必填，请填写数字',
    RULE_R_NUM_2: '请填写17位内的数字(可包含小数点后两位)',
    RULE_R_NUM_3: '请填写小数点后两位的数字',
    RULE_R_NUM_4: '请填写17位内的数字',
    RULE_R_NUM_5: '请填写正数',
    RULE_R_NUM_6: '请填写1~2的整数',
    RULE_R_NUM_7: '请填写数字或小数',
    RULE_R_NUM_8: '请填写正整数',
    RULE_NUM: '请填写数字',
    RULE_R: '此字段为必填',
    RULE_R_LASTNAME: '联络人姓氏为必填',
    RULE_R_LASTNAME_2: '姓氏为必填',
    RULE_R_LASTNAME_3: '使用者姓氏为必填',
    RULE_R_FIRSTNAME: '名称为必填',
    RULE_R_COMPANY_NAME: '公司名称为必填',
    RULE_R_OPPTY_NAME: '商机名称为必填',
    RULE_R_OPPTY_Contact: '客户名称为必填',
    RULE_R_Case_Contact: '客户名称为必填',
    RULE_R_TEMPLATE_NAME: '模板名称为必填',
    RULE_R_Case: '案件名称为必填',
    RULE_R_SEGMENT: '分群名称为必填',
    RULE_R_CAMPAIGN: '活动名称为必填',
    RULE_R_ACCOUNT: '联络人账号为必填',
    RULE_R_PROCESS: '流程名称为必填',
    RULE_R_STAGE: '阶段名称为必填',
    RULE_R_TITLE: '标题为必填',
    RULE_R_NAME: '名称为必填',
    RULE_R_ADDRESS: '地址为必填',
    RULE_HTTP: '开头请填写 http://或 https://',
    RULE_URL: '请填写正确URL格式',
    RULE_EMAIL: '请填写正确E-mail格式',
    RULE_PHONE: '请填写正确电话号码格式',
    RULE_PHOTO: '请上传图档',
    RULE_CSV: '请上传CSV檔',
    RULE_FILE: '附件档案总共不能超过20MB',
    RULE_FILE_2: '照片大小请小于1MB',
    RULE_FILE_3: '档案大小请小于{size}MB',
    RULE_FILE_4: '照片大小请小于20MB',
    RULE_FILE_5: '档案总共不能超过3个',
    RULE_DUE_DATE: '预期结案日期为必填',
    RULE_PROCCESS: '交易流程为必选',
    RULE_FORECAST: '预测类别为必选',
    RULE_REASON: '失败原因为必选',
    RULE_NOTE: '备注内容为必填',
    RULE_NOTE_1000: '备注内容不可超过1000字',
    RULE_DATE: '请填选正确日期格式 YYYY-MM-DD',
    RULE_DATETIME: '请填选正确格式 YYYY-MM-DD HH:mm',
    RULE_5: '字数请限制在5字内',
    RULE_9: '字数请限制在9字内',
    RULE_10: '字数请限制在10字内',
    RULE_16: '字数请限制在16字内',
    RULE_17: '字数请限制在17字内',
    RULE_20: '字数请限制在20字内',
    RULE_30: '字数请限制在30字内',
    RULE_50: '字数请限制在50字内',
    RULE_10_50: '字数请限制在10~50字内',
    RULE_60: '字数请限制在60字内',
    RULE_70: '字数请限制在70字内',
    RULE_86: '字数请限制在86字内',
    RULE_90: '字数请限制在90字内',
    RULE_100: '字数请限制在100字内',
    RULE_200: '字数请限制在200字内',
    RULE_250: '字数请限制在250字内',
    RULE_300: '字数请限制在300字内',
    RULE_500: '字数请限制在500字内',
    RULE_1000: '字数请限制在1000字内',
    RULE_10000: '字数请限制在10000字内',
    RULE_NULL: '请输入文字',
    RULE_HHMM: '格式应为HH:MM',
    RULE_PROGRESS: '请填入0-100',
    RULE_CF_1: "选项不可重复",
    RULE_CF_2: '选项不可包含","',
    RULE_ALPHA_NUMERIC: '请输入英文字母、数字或下划线',
    NO_SPECIAL_SYMBOL: '請輸入中/英文、數字或底線及空白',
    RULE_LOWER_ALPHA_NUMERIC: '请输入小写英文字母、数字或下划线',
  },
  BREADCRUMBS: {
    Contacts: '联络人',
    Companies: '公司',
    Deals: '商机',
    Case: '客服案件',
    Campaign: '营销活动',
    Segment: '客户分群',
    KnowledgeArticles: '知识库文章',
    Order: '订单',
    WIADVANCE_Order: '合约',
  },
  //-----DASHBOARD
  DASHBOARD: {
    TITLE: '商机案件仪表板',
    EXPECTED_REVENUE: '预期营收',
    SUCCESSFULLY_CLOSED: '成功结案',
    CURRENT_PERIOD: '本期结算',
    EMAIL_PERFORMANCE: '邮件成效',
    STAGE_AMOUNT: '各阶段金额',
    SALES_RANKING: '销售排行',
    LATEST_OPPTY: '最新商机',
    WITHIN_30_DAYS: '30天内',
    BEST_OPPTY: '最佳商机',
    TOP_5: '前五名',
    TODAY: '今天',
    THIS_YEAR: '今年',
    THIS_SEASON: '本季',
    THIS_MONTH: '本月',
    THIS_WEEK: '本周',
    SELECT_DATE: '选择日期',
    //----Headers
    OPPTY_OWNER: '商机拥有者',
    CONTACT_NAME: '客户名称',
    OPPTY_NAME: '商机名称',
    CURRENT_STAGE: '目前阶段',
    CREATED_TIME: '建立时间',
    AMOUNT: '金额',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    THIS_PERIOD: '本期',
    PREVIOUS: '前期',
    DIFFERENCE: '相差',
    QUANTITY_SENT: '已寄出数量',
    READ: '已阅读数量',
    CLICKED: '已点击邮件连结',
    UNKNOWN: '不明',
    GO_OPPTY: '前往商机'
  },
  //------- CONTACT
  CONTACT: {
    TITLE: '联络人',
    BULK: '推播',
    SEGMENT: '建立客户分群',
    EMAIL_PUSH: 'Email推播',
    SMS_PUSH: 'SMS推播',
    WIADVANCE_REPEAT_EMAIL: "警告:重复Email。如果确认要更新，关闭本窗口后，继续执行。",
    WIADVANCE_WRONG_CUSTOMER_CODE: "对应公司没有customer code，或是在BC没有对应公司",
    WIADVANCE_CREATE_CONTACT_FAIL: "BC同步失败，将退回原始数据",
    MESSAGE_DELETE: '您确定要删除此联络人吗？',
    MESSAGE_FIRST: '请先删除',
    MESSAGE_OPPTY: '相关商机',
    MESSAGE_OPPTY_2: '相关商机',
    MESSAGE_CASE: '相关案件',
    MESSAGE_CASE_2: '相关案件',
    MESSAGE_ALL: '请先删除相关商机或案件',
    MESSAGE_ERROR: '此联络人有商机正在进行，请指派他人后再删除',
  },
  ADDSTATICSEGMENT: {
    TITLE: '新增静态客户分群',
    NAME: '客户分群名称',
  },
  CONTACT_DETAIL: {
    TITLE: '职称',
    ORG_NAME: '公司名称',
    OWNER: '联络人拥有者',
    CONTACT_INFORMATION: '联络人信息',
    FIRST_NAME: '名称',
    LAST_NAME: '姓氏',
    MOBILE_PHONE: '移动电话',
    OFFICE_PHONE: '联络电话',
    BIRTHDAY: '生日',
    ADDRESS: '地址',
    SUB_ADDRESS: '地址2',
    CITY: '城市',
    COUNTRY: '国家',
    LEVEL: '级别',
    ZIP_CODE: '邮政编码',
    DEPARTMENT: '部门',
    PROVINCE: '省份',
    RELATED_CAMPAIGN: '相关活动',
    DESCRIPTION: '描述',
    COMPANY_INFORMATION: '公司信息',
    ADD_COMPANY_INFORMATION: '新增公司信息',
    NO_COMPANY_INFORMATION: '尚无公司信息',
    COMPANY_NAME: '公司名称',
    JURISTIC_PERSON_NAME: '法人名称',
    POSITION: '职位',
    SHAREHOLDING: '持股',
    FAX: '传真',
    ENG_FIRST_NAME: '(英)名称',
    ENG_LAST_NAME: '(英)姓氏',
    ENG_TITLE: '(英)职称',
    ENG_DEPARTMENT: '(英)部门',
    INVOICE_RECIEVED: '发票接收',
    MAILING_ADDRESS: '地址2',
    //----NOTE
    ADD_NOTE: '新增备注',
    NO_NOTE: '尚无备注',
    //----Oppyt
    NO_DEAL: '尚无商机',
    //----Timeline   
    TIMELINE: '时间轴',
    NO_TIMELINE: '尚无时间轴',
    TIMELINE_TITLE: '职称已更改为',
    TIMELINE_DEPARTMENT: '部门已更改为',
    TIMELINE_LEVEL: '级别已更改为',
    TIMELINE_OWNER: '联络人拥有者已更改为',
    //----TAB
    DETAIL: '详细资料',
    NOTE: '备注',
    EMAIL: '电邮',
    SMS: '简讯',
    UPCHAT: '历史讯息',
    ALL_OPPORTUNITIES: '所有商机',
    ALL_CASES: '所有案件',
    DEAL: '商机名称',
    STAGE: '目前阶段',
    //----MESSAGE
    MESSAGE: '您确定要删除此备注吗？',
    MESSAGE_2: '您确定要删除此商机吗？',
    MESSAGE_3: '您确定要删除此联络人吗？',
    MESSAGE_4: '您确定要复制此联络人吗？',
    MESSAGE_5: '您确定要删除此联络人的公司信息吗？',
    ERROR: '请选择图档',
    ERROR_2: '照片请小于5MB',
    ERROR_3: '请输入正确格式',
    ERROR_4: '未输入公司名称',
    ERROR_5: '已有此间公司',
    ERROR_6_1: '此联络人为商机',
    ERROR_6_2: '之客户，请重新指派客户后再行删除',
    ERROR_7: '此联络人相关商机正在进行，请重新指派再删除',
    ERROR_8: '此联络人无公司信息',
  },
  ADD_CONTACT: {
    TITLE: '新增联络人',
    FIRST_NAME: '联络人名称',
    LAST_NAME: '联络人姓氏',
    SELECT_LABEL: '地区',
    MOBILE_PHONE: '移动电话',
    OFFICE_PHONE: '办公室电话',
    LEVEL: '级别',
    ORG_NAME: '公司名称',
    IMAGE: '更新联络人照片',
    CN_TITLE: '职称',
    DEPARTMENT: '部门',
    ENG_FIRST_NAME: '(英)联络人名称',
    ENG_LAST_NAME: '(英)联络人姓氏',
    ENG_TITLE: '(英)职称',
    ENG_DEPARTMENT: '(英)部门',
    INVOICE_RECIEVED: '发票接收',
    MAILING_ADDRESS: '地址2',
  },
  EDIT_CONTACT: {
    TITLE: '修改联络人',
    FIRST_NAME: '联络人名称',
    LAST_NAME: '联络人姓氏',
    SELECT_LABEL: '地区',
    MOBILE_PHONE: '移动电话',
    OFFICE_PHONE: '办公室电话',
    LEVEL: '级别',
    ORG_NAME: '公司名称',
    IMAGE: '更新联络人照片',
  },
  ADDCONTACTORG: {
    TITLE: '新增公司信息',
    COMPANY_NAME: '公司名称',
    JURISTIC_PERSON_NAME: '法人名称',
    POSITION: '职位',
    SHAREHOLDING: '持股',
    ERROR: '已有此间公司',
  },
  //------- COMPANY
  COMPANY: {
    TITLE: '公司',
    VCF: 'VCF申请',
    //----MESSAGE
    MESSAGE: '您确定要删除此公司吗？',
    MESSAGE_2_1: '请先删除',
    MESSAGE_2_2: '相关商机',
    MESSAGE_2_3: '相关案件',
    MESSAGE_3: '请先删除相关商机或案件',
    WIADVANCE_REPEAT_CUSTOMERCODE: "Customer Code 不可重复，请确认是否有已建立的公司",
  },
  COMPANY_DETAIL: {
    PHONE: '电话',
    ADDRESS: '地址',
    SUB_ADDRESS: '地址2',
    WEB: '网站',
    OWNER: '拥有者',
    INFO: '公司信息',
    NAME: '公司名称',
    NAME_EN: '(英) 公司名称',
    COMPANY_NUMBER: '统一编号',
    FAX: '传真',
    TYPE: '类型',
    INDUSTRY: '行业别',
    EMPLOYEE: '员工人数',
    ANNUAL_REVENUE: '营业额',
    REGISTERED_CAPITAL: '资本额',
    ESTABLISH_DATE: '成立日期',
    RELATED_CAMPAIGN: '相关活动',
    DESCRIPTION: '描述',
    CITY: '城市',
    COUNTRY: '国家',
    LEVEL: '级别',
    ZIP_CODE: '邮政编码',
    PROVINCE: '省份',
    CLOSING_DATE: '关帐日',
    PAYMENT_TERM: '付款条件',
    REGULAR_PAYMENT_DATE: '固定付款日',
    BELONG_GROUP: '所属集团',
    //----NOTE
    ADD_NOTE: '新增备注',
    NO_NOTE: '尚无备注',
    //----Oppyt
    NO_DEAL: '尚无商机',
    STAGE: '目前阶段',
    //----primary contact
    CONTACT: '主要联络人',
    NO_CONTACT: '尚无主要联络人',
    //----Timeline   
    TIMELINE: '时间轴',
    NO_TIMELINE: '尚无时间轴',
    TIMELINE_EMPLOYEE: '员工人数已更改为',
    TIMELINE_REVENUE: '年度营业额已更改为 $',
    TIMELINE_CAPITAL: '公司资本额已更改为 $',
    TIMELINE_OWNER: '联络人拥有者已更改为',
    TIMELINE_PEOPLE: '人',
    //----TAB
    DETAIL: '详细资料',
    NOTE: '备注',
    ALL_OPPORTUNITIES: '所有商机',
    ALL_CASES: '所有案件',
    DEAL: '商机名称',
    //----MESSAGE
    MESSAGE: '您确定要删除此备注吗？',
    MESSAGE_2: '您确定要删除此商机吗？',
    MESSAGE_3: '您确定要删除此公司吗？',
    ERROR: '请选择图档',
    ERROR_2: '照片请小于5MB',
  },
  ADD_COMPANY: {
    TITLE: '新增公司',
    ORG_NAME: '公司名称',
    TYPE: '类型',
    INDUSTRY: '行业别',
    IMAGE: '上传客户LOGO',
    WEB: '网站',
    PHONE: '电话',
    FAX: '传真',
    ADDRESS: '地址',
    EMPLOYEE: '员工人数',
    COMPANY_NUMBER: '统一编号',
    COUNTRY: '国家',
    ZIP_CODE: '邮政编码',
    CITY: '城市',
    PAYMENT_TERM: '付款条件'
  },
  Edit_COMPANY: {
    TITLE: '修改公司',
    ORG_NAME: '公司名称',
    TYPE: '类型',
    INDUSTRY: '行业别',
    IMAGE: '上传客户LOGO',
    WEB: '网站',
    PHONE: '电话',
    FAX: '传真',
    ADDRESS: '地址',
    EMPLOYEE: '员工人数',
  },
  ADDMAINCONTACT: {
    TITLE: '新增公司联络人',
    TITLE_2: '修改公司联络人',
    NEW_CONTACT: '建立全新联络人',
    OLD_CONTACT: '选择已有联络人',
    CONTACT_NAME: '联络人姓名',
    FIRST_NAME: '联络人名称',
    LAST_NAME: '联络人姓氏',
    JURISTIC_PERSON_NAME: '法人名称',
    POSITION: '职位',
    SHAREHOLDING: '持股',
    PRIMARY_CONTACT: '主要联络人',
    ERROR: '如需新增全新联络人，请点选上方＂新增全新联络人＂按钮。如无此需求，请选择已建立之联络人',
  },
  MAINCONTACTS: {
    TITLE: '公司联络人',
    PRIMARY: '主要',
    CONTACT_NAME: '联络人姓名',
    JURISTIC_PERSON_NAME: '法人名称',
    POSITION: '职位',
    SHAREHOLDING: '持股',
    PHONE: '电话',
    MAIL: '电子邮件',
    ACTIVE: '执行',
    MESSAGE: '您确定要删除此联络人吗？',
  },
  //------- DEAL
  DEAL: {
    TITLE: '商机',
    OPPTIES: '商机',
    NO_DEAL: '尚无商机',
    NO_DEAL_STAGE: '尚无商业流程',
    PROCESS: '商业流程',
    //----MESSAGE
    MESSAGE: '您确定要删除此商机吗？',
    ERROR: '请先建立商业流程',
    DELETE_ERROR: '以下商机已结案，不可删除。',
  },
  DEAL_DETAIL: {
    CHANGE_STAGE: '变更商业流程',
    REOPEN: '重启商机',
    NAME: '商机名称',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    CREATED_ON: '建立日期',
    STATUS: '状态',
    AMOUNT: '金额',
    SCORE: '分数',
    PROGRESS: '达标率',
    OWNER: '商机拥有者',
    CLIENT_NAME: '客户名称',
    NEW_CLIENT: '建立全新客户',
    CONTACT: '主要联络人',
    OPPTY_CONTACT: '商机联络人',
    NO_OPPTY_CONTACT: '尚无主要联络人',
    CLIENT_BUDGET: '客户预算',
    FORECAST_CATEGORY: '预测类别',
    RELATED_CAMPAIGN: '相关活动',
    CUSTOMER_NEEDS: '客户需求',
    PURCHASE_NEEDS_OR_PROCESS: '采购需求/流程',
    EXPECT_OR_NEXTSTEPS_OR_OTHERS: '期望/后续步骤/其他',
    SALES_NOTES: '业务注记',
    OPPTY_STATUS: '商机状态',
    INDUSTRY: '产业类别',
    CUSTOMER_SOURCE: '客户来源',
    OTHER_CUSTOMER_SOURCE: '其他客户来源',
    PROGRESS_2: '进度',
    OPPTY_TYPE: '商机类型',
    SERIAL_NUMBER: '商机编号',
    ENDACCOUNT: '终端客户',
    WIADVANCR_CUSTOMER_SOURCE: '商机「客户来源」若为「业务商机」，Customer Code为必填',
    //----Timeline   
    TIMELINE: '时间轴',
    NO_TIMELINE: '尚无时间轴',
    NO_AMOUNT_CHANGE: '尚无金钱变更',
    NO_STAGE_CHANGE: '尚无阶段变更',
    NO_FIELD_CHANGE: '尚无其他变更',
    NO_ACTIVITY_CHANGE: '尚无活动纪录',
    NO_MAIL: '尚无电邮',
    NO_SMS: '尚无简讯',
    NO_NOTE: '尚无备注',
    TIMELINE_AMOUNT: '商机金额已更改为 $',
    TIMELINE_NAME: '商机名称已更改为',
    TIMELINE_FORECAST: '预测类别已更改为',
    TIMELINE_PROCESS: '商机流程已更改为',
    TIMELINE_OWNER: '联络人拥有者已更改为',
    TIMELINE_ECD: '商机预期结案日已更改为',
    SOON_DUE: "即将于",
    SOON_DUE_1: '天后到期',
    SOON_DUE_2: "已过期超过",
    SOON_DUE_3: "天",
    SOON_DUE_4: "今天到期",
    //----TAB      
    DETAIL: '详细资料',
    NOTE: '备注',
    EMAIL: '电邮',
    SMS: '简讯',
    ALL_CASES: '所有案件',
    //----timeLineType
    TIMELINE_TAB_ALL: '全部',
    TIMELINE_TAB_AMOUNT: '金钱变更',
    TIMELINE_TAB_STAGE: '阶段变更',
    TIMELINE_TAB_FIELD: '其他变更',
    TIMELINE_TAB_MAIL: '电邮',
    TIMELINE_TAB_SMS: '简讯',
    TIMELINE_TAB_NOTE: '备注',
    //----MESSAGE
    MESSAGE: '您确定要删除此备注吗？',
    MESSAGE_2: '您确定要删除此商机吗？',
    MESSAGE_3: '结案日期将会被覆盖，请问是否仍要重启？',
  },
  ADD_DEAL: {
    TITLE: '新增商机',
    NAME: '商机标题',
    ORG: '选择公司',
    CONTACT: '选择联络人',
    NO_CONTACT: '请输入联络人姓名进行搜寻',
    NEW_CONTACT: '建立全新联络人',
    OLD_CONTACT: '选择已有联络人',
    AMOUNT: '商机金额',
    PROCESS: '请选择商业流程',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    FORCAST: '预测类别',
    DEAL_PROCESS: '商业流程',
    ERROR: '必须选择已建立的交易流程',
    ERROR_2: '必须选择已建立的联络人或点击全新联络人',
    ERROR_3: '客户与公司须至少填其一',
  },
  TO_DEAL: {
    NAME: '客户名称',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    AMOUNT: '金额',
    SCORE: '分数',
    PROGRESS: '达标率',
    OWNER: '商机拥有者',
    INFO: '基本数据',
    GUIDE: '成功指引',
    BUDGET: '确认预算',
    PROBABILITY: '可能性',
    DESCRIPTION: '描述',
    DETAIL_PAGE: '前往页面',
    IN: '于',
    LOST: '失败',
    CLOSED: '结案',
    WIN: '成功结案',
    BECAUSE: '因'
  },
  RELATEDCONTACTS: {
    TITLE: '联络人',
    NEW_CONTACT: '建立全新联络人',
    OLD_CONTACT: '选择已有联络人',
    FIRST_NAME: '联络人名称',
    LAST_NAME: '联络人姓氏',
    NO_CONTACT: '请输入联络人姓名进行搜寻',
    ADD_CONTACT: '新增联络人',
    CONTACT_NAME: '联络人姓名',
    ORG_NAME: '公司名称',
    PHONE: '电话',
    MAIL: '电子邮件',
    ACTIVE: '执行',
    MESSAGE: '您确定要删除此联络人吗？',
    ERROR: '如需新增全新联络人，请点选上方＂新增全新联络人＂按钮。如无此需求，请选择已建立之联络人',
  },
  CHILD_CASE: {
    TITLE: '子案件',
    SUBJECT: '主题',
    CONTACT: '联络人',
    PRIORITY: '优先等级',
    STATUS: '状态',
    GROUP: '组别',
    TYPE: '类型',
    OWNER: '客服人员',
    CLOSED_DATE: '结案日期',
    ACTIVE: '执行',
    ADD_CHILD_CASE: '新增子案件',
    NO_CHILD_CASE: '无符合搜寻字词的结果',
    SEARCH_CHILD_CASE: '请输入案件标题进行搜寻',
    MESSAGE: '您确定要删除此子案件吗？',
    ERROR: '请选择已建立之案件'
  },
  EDITDEALDATE: {
    TITLE: '修改预期结案日',
    NAME: '商机名称',
    EXPECTED_CLOSE_DATE: '预期结案日期',
  },
  //------- Case
  CASE: {
    TITLE: '客服案件',
    CASE: '案件',
    NO_CASE: '尚无案件',
    NO_CASE_STAGE: '尚无案件流程',
    FINISH: '结案',
    CLOSED: '关闭',
    CASE_NUMBER: '案件编号',
    OWNER: '客服人员',
    //----MESSAGE
    MESSAGE: '您确定要删除此案件吗？',
    ERROR: '请先建立案件流程',
    DELETE_ERROR: '以下案件已结案，不可删除。',
  },
  CASE_DETAIL: {
    CHANGE_STAGE: '变更案件流程',
    CLOSED: '结案',
    REOPEN: '重启案件',
    IN: '于',
    CONTACT: '主要联络人',
    PHONE: '进线电话',
    EMAIL: '进线电邮',
    EMAIL_2: '电邮',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    CREATED_ON: '建立日期',
    PRIORITY: '优先等级',
    STATUS: '状态',
    OWNER: '客服人员',
    GUIDE: '客服指引',
    DAY: '天',
    CASE_NAME: '案件标题',
    CASE_NUMBER: '案件编号',
    ORG_NAME: '公司名称',
    INCOMING_CONTACT: '进线联络人',
    SOURCE: '案件来源',
    GROUP: '案件组别',
    TYPE: '案件类型',
    CASE_STATUS: '案件状态',
    RELATED_CAMPAIGN: '相关活动',
    DESCRIPTION: '案件描述',
    DESCRIPTION_2: '案件处理',
    PARENT_CASE: '母案件',
    //----TAB
    DETAIL: '详细资料',
    NOTE: '备注',
    SMS: '简讯',
    PRO: "产品",
    RELATED_ARTICLE: '相关文章',
    ALL_ARTICLE: '所有文章',
    STAGE_CHANGE: '阶段变更',
    STATUS_CHANGE: '状态变更',
    FIELD_CHANGE: '其他变更',
    SUBJECT: '标题',
    CLOSED_DATE: '结案日期',
    //----Timeline   
    TIMELINE: '时间轴',
    NO_TIMELINE: '尚无时间轴',
    NO_STAGE_CHANGE: '尚无阶段变更',
    NO_STATUS_CHANGE: '尚无状态变更',
    NO_FIELD_CHANGE: '尚无其他变更',
    NO_NOTE: '尚无备注',
    NO_MAIL: '尚无电邮',
    NO_SMS: '尚无简讯',
    ADD_NOTE: '新增备注',
    ADD_PRO: '新增产品',
    DEL_PRO: '全部删除',
    CASE_CLOSED: '案件已关闭',
    TIMELINE_OWNER: '联络人拥有者已更改为',
    TIMELINE_NAME: '案件名称已更改为',
    TIMELINE_CONTACT: '主要联络人已更改为',
    TIMELINE_STATUS: '案件状态已更改为',
    TIMELINE_PRIORITY: '优先等级已更改为',
    TIMELINE_GROUP: '所属部门已更改为',
    TIMELINE_TYPE: '案件类型已更改为',
    TIMELINE_DUE_DATE: '预期结案日已更改为',
    TIMELINE_CASE_PROCESS: "案件处理流程已更改为",
    //----Right
    PRIMARY_CONTACT_CASE: '主要联络人相关案件',
    NO_RELATED_CASE: '尚无其他相关案件',
    RELATED_CONTACT: '案件相关联络人',
    NO_RELATED_CONTACT: '尚无相关联络人',
    CHILD_CASE: '子案件',
    NO_CHILD_CASE: '尚无相关子案件',
    KNOWLEDGE_ARTICLE: '知识库文章',
    NO_RELATED_ARTICLE: '尚无相关文章',
    EXPAND: '展开',
    COLLAPSE: '收起',
    REMOVE: '移除',
    ADD: '添加',
    //----MESSAGE
    MESSAGE: '您确定要删除此备注吗？',
    MESSAGE_2: '您确定要删除此案件吗？',
    MESSAGE_3: '结案日期将会被覆盖，请问是否仍要重启？',
    MESSAGE_4: '是否要与所有子案件一同结案？',
    ERROR: '请输入正确格式',
  },
  ADD_CASE: {
    TITLE: '新增案件',
    NAME: '案件标题',
    ORG: '选择公司',
    CONTACT: '选择联络人',
    NO_CONTACT: '请输入联络人姓名进行搜寻',
    NEW_CONTACT: '建立全新联络人',
    OLD_CONTACT: '选择已有联络人',
    PHONE: '进线电话',
    EMAIL: '进线电邮',
    SOURCR: '案件来源',
    GROUP: '案件组别',
    TYPE: '案件类型',
    PARENT_CASE: '母案件',
    CATEGORY: '案件分类',
    EXPECTED_CLOSE_DATE: '预计结案日期',
    SELECT: '请选择案件处理流程',
    PROCESS: '案件流程',
    ERROR: '必须选择已建立的交易流程',
    ERROR_2: '必须选择已建立的联络人或点击全新联络人',
    ERROR_3: '客户与公司须至少填其一',
    ERROR_4: '请选择已建立之案件',
    USE_AUTONUMBER: "自动填入流水号",
  },
  TO_CASE: {
    NAME: '客户名称',
    EXPECTED_CLOSE_DATE: '预期结案日期',
    PRIORITY: '优先等级',
    SCORE: '分数',
    STATUS: '状态',
    OWNER: '客服人员',
    GUIDE: '客服指引',
    BUDGET: '确认预算',
    DETAIL_PAGE: '前往页面',
    IN: '于',
    LOST: '失败',
    CLOSED: '结案',
    WIN: '成功结案',
    SOLVE: '解决'
  },
  ADD_CASE_PRODUCT: {
    TITLE: '产品列表',
  },
  //------- Bulk Message
  Bulk_Message: {
    TITLE: '推播讯息',
  },
  //------- Segment
  SEGMENT: {
    TITLE: '客户分群',
    //----MESSAGE
    MESSAGE: '您确定要删除此分群吗？',
    MESSAGE_2_1: '请先删除',
    MESSAGE_2_2: '相关活动',
    MESSAGE_3: '请先删除相关活动',
    //----head
    NAME: '客户分群名称',
    TYPE: '分群类型',
    PEOPLE: '分群人数',
    CAMPAIGNS: '相关营销活动总数',
    OWNER: '拥有者',
    ACTIVE: '执行',
  },
  ACTIVITY: {
    ADD: '新增活动',
    TITLE: '活动',
    PRIORITY: '优先度',
    COMPLETED: '已完成',
    MARK_COMPLETED: '标记为已完成',
    REGARDING: '相关',
    TIME_FRAME: '时间区间',
    TYPE: '种类',
    OWNER: '负责人',
    SUBJECT: '主旨',
    PROGRESS: '进度',
    REMARK: '备注',
    CONTACT: '联络人',
    ORG: '公司',
    URGENT: '紧急',
    IMPORTANT: '重要',
    MEDIUM: '一般',
    LOW: '低',
    START_TIME: '起始时间',
    DUE_TIME: '到期时间',
    START_DAY: '起始日',
    END_DAY: '到期日',
    COMPLETED_UNCOMPLETED: '未完成',
    COMPLETED_COMPLETED: '完成',
    UNCOMPLETED_ACTIVITY: '未完成活动',
    TYPE_SETTING: '活动种类',
    TYPE_NAME: '种类名称',
    TYPE_COLOR: '颜色',
    TYPE_ICON: '图示',
    ADD_TYPE: '新增活动种类',
    ADD_TYPE_BTN: '新增种类',
    MESSAGE_DELETE: '您确定要删除此活动吗？',
    MONTH: '月份',
    WEEK: '周',
    DAY: '日',
    TODAY: "今日",
    MORE: " {0} 更多",
    MONDAY: "星期一",
    TUESDAY: "星期二",
    WEDNESDAY: "星期三",
    THURSDAY: "星期四",
    FRIDAY: "星期五",
    SATURDAY: "星期六",
    SUNDAY: "星期日",
    DELETE_ERROR: '无权限删除以下活动:',
    NO_CONTACT: "找不到联络人",
    NO_ORG: "找不到公司",
    NO_REGARDING: "找不到案件或商机",
    WIADVANCE_NO_REGARDING: "找不到商机",
    NOT_FOUND_404: "活动不存在或已被删除",
  },
  SEGMENT_DETAIL: {
    CONTACTS: '联络人总数',
    CAMPAIGNS: '活动总数',
    TYPE: '推播类型',
    OWNER: '客户分群拥有者',
    DESCRIPTION: '分群描述',
    INFO: '分群信息',
    NAME: '名称',
    RELATED_CAMPAIGN: '相关活动',
    TIME: '次',
    DELETE_CONTACT: '删除联络人',
    ADD_CONTACT: '新增联络人',
    CAMPAIGN_Analysis_Chart: '活动分析图表',
    NO_DATA: '尚无资料',
    CAMPAIGN_Analysis_Statistics: '活动分析统计',
    NO_CAMPAIGN_DATA: '尚无活动资料',
    //----TAB
    SETUP: '基本数据',
    CONTACT: '联络人',
    ANALYSIS: '分析',
    C_NAME: '联络人姓名',
    C_ORG: '公司名称',
    C_PHONE: '联络电话',
    C_MAIL: '电子邮件',
    C_AMOUNT: '总金额',
    C_OWNER: '拥有者',
    C_ACTIVE: '执行',
    CAM_NAME: '营销活动名称',
    CAM_TYPE: '类型',
    CAM_TIME: '活动次数',
    S_V_S: '成功总数 vs 寄送总数',
    O_V_S: '开启总数 vs 成功总数',
    C_V_S: '点击总数 vs 成功总数',
    S_V_O: '成功总数 vs 开启总数',
    S_V_C: '成功总数 vs 点击总数',
    SUCCESS: '成功总数',
    SENT: '寄送总数',
    OPEN: '开启总数',
    CLICK: '点击总数',
    END_TIME: '最后发送时间',
    //----MESSAGE
    MESSAGE: '您确定要删除此分群吗？',
    MESSAGE_2: '您确定要删除此联络人吗？',
    ERROR: '请先删除相关活动',
  },
  ADD_SEGMENT: {
    TITLE: '新增分群',
    NAME: '分群名称',
    TYPE: '分群类型',
    DESCRIPTION: '描述',
    MESSAGE: '新分群已建立，点选确认前往查看',
  },
  EDIT_SEGMENT: {
    TITLE: '修改分群',
    NAME: '分群名称',
    TYPE: '分群类型',
    DESCRIPTION: '描述',
  },
  ADDSEGMENTCONTACT: {
    TITLE: '分群联络人',
    ADD_CONTACT: '确认新增联络人',
    FIRST_NAME: '联络人名称',
    ORG_NAME: '公司名称',
    PHONE: '电话',
    MAIL: '电子邮件',
  },
  //------- CAMPAIGN
  CAMPAIGN: {
    TITLE: '营销活动',
    //----MESSAGE
    MESSAGE: '确定要删除此营销活动吗？',
    MESSAGE_2: '确定要删除这些营销活动吗？',
    ERROR: '请先建立客户分群',
    ERROR_2: '此营销活动使用中',
    ERROR_3: '以下营销活动使用中',
    //----head
    NAME: '营销活动名称',
    CHANNEL: '推播渠道',
    SEGMENT: '客户分群',
    PEOPLE: '活动参与人数',
    OWNER: '拥有者',
    ACTIVE: '执行',
  },
  CAMPAIGN_DETAIL: {
    STATUS: '状态',
    CHANNEL: '推播渠道',
    PEOPLE: '活动参与人数',
    SEGMENT: '客户分群',
    OWNER: '营销活动拥有者',
    DESCRIPTION: '活动描述',
    NAME: '名称',
    TYPE: '活动分类',
    START_TIME: '开始日期',
    END_TIME: '结束日期',
    TEMPLATE: '选择样板',
    EMAIL_CONTENT: 'Email内容：',
    SMS_CONTENT: 'SMS内容：',
    PREVIEW: '预览',
    SENTING: '寄送中...',
    NO_O365: '您还未设定您的M365账号。如果要寄送电邮，请至设定>Email同步设定M365账号。谢谢！',
    INVALID_O365_TOKEN: '您的设置M365账号长时间未使用。请转到设定>Email同步删除现有的M365账号并重新设置。谢谢！',
    GO_SETTING: '前往设定',
    SUBJECT: '主旨',
    SMS_CONTENT_2: '简讯内容',
    CAMPAIGN_Analysis_Chart: '活动分析图表',
    NO_DATA: '尚无资料',
    CAMPAIGN_Analysis_Statistics: '活动分析统计',
    NO_CAMPAIGN_DATA: '尚无活动资料',
    ATTACHMENT: '附件',
    //----TAB
    CAM_NAME: '营销活动名称',
    END_TIME_2: '最后发送时间',
    SETUP: '基本数据',
    ANALYSIS: '分析',
    //----MESSAGE
    MESSAGE: '确定要删除此营销活动吗？',
    ERROR: '请输入Email主旨',
    ERROR_2: '请输入内容',
    ERROR_3: '请先在客户分群新增联络人。',
  },
  ADD_CAMPAIGN: {
    TITLE: '新增营销活动',
    CHANNEL: '推播渠道',
    NAME: '活动名称',
    SEGMENT: '客户分群',
    DESCRIPTION: '活动描述',
  },
  EDIT_CAMPAIGN: {
    TITLE: '修改营销活动',
    CHANNEL: '推播渠道',
    NAME: '活动名称',
    SEGMENT: '客户分群',
    DESCRIPTION: '活动描述',
  },
  CAMPAIGNCONTACTLIST: {
    TITLE: '活动纪录联络人',
    ADD_SEG: '建立客户分群',
    Success: '成功寄送',
    unSuccess: '未成功寄送',
    Open: '已开启信件',
    unOpen: '未开启信件',
    Link: '已点击连结',
    unLink: '未点击连结',
    CONTACT_NAME: '联络人姓名',
    ORG_NAME: '公司名称',
    PHONE: '电话',
    MAIL: '电子邮件',
  },
  //------- KnowledgeArticles
  KNOWLEDGE_ARTICLE: {
    TITLE: '知识库文章',
    MESSAGE: '您确定要删除此文章吗？',
    //----Headers
    H_TITLE: '文章标题',
    NUMBER: '知识库文章编号',
    STATUS: '状态',
    UPDATED_ON: '最后更新时间',
    AUTHOR: '作者',
    ACTIVE: '执行',
  },
  KNOWLEDGE_ARTICLE_DETAIL: {
    NUMBER: '文章编号',
    SUBJECT: '文章主题',
    STATUS: '文章状态',
    AUTHOR: '作者',
    TITLE: '标题',
    AUTONUMBER: '编号',
    SUBJECT_1: '主题',
    STATUS_2: '状态',
    KEYWORD: '关键词',
    DESCRIPTIONL: '描述',
    AUTONUMBER_1: '文章编号将自动生成',
    //-----BREADCRUMBS   
    KNOWLEDGEARTICLES: '知识库文章',
    ADD_KNOWLEDGEARTICLES: '新增知识库文章',
    //----TAB
    DETAIL: '详细资料',
    //----MESSAGE
    MESSAGE: '您确定要删除此文章吗？',
    MESSAGE_2: '您确定要发布此文章吗？',
    MESSAGE_3: '您确定要重启编辑此文章吗？',
    ERROR: '请输入文章内容',
  },
  PREFERENCES: {
    PREFERENCE: "Preference",
    ADD_PREFERENCE: "新增",
    TENANT: "租户",
    CODE: "Code",
    VALUE: "值",
    NAME: "名称",
    DESCRIPTION: "描述",
    ACTIVE: "执行",
    MESSAGE: "您确定要删除此Preference吗？",
    ERROR: "此CODE已存在。",
    ERROR1: "：格式错误并不是JSON",
    RULE_UPPERCASE: "必须是大写英文字母或底线"
  },
  //------- Setting
  SETTING: {
    TITLE: '设定',
    PERSONALSETTING: '个人化设定',
    PASSWORDANDLOGIN: '登入与安全性',
    EMAILSYNC: 'Email 同步',
    EMAILTEMPLATE: 'Email 寄件范本',
    SMSTEMPLATE: 'SMS 寄件范本',
    MANAGEUSERS: '使用者管理',
    MANAGEGROUPS: '团队管理',
    CUSTOMFIELDS: '自定义字段',
    TABLESETTING: '自定义数据表',
    FILTERSETTING: '自定义筛选',
    PIPELINESTAGESETTING: '商业流程设定',
    CUSTOMERSERVICESETTING: '客户服务选项',
    KNOWLEDGEARTICLESUBJECTSETTING: '知识库文章主题',
    AUTONUMBERSETTING: '流水号设定',
    PRODUCTSETTING: '产品设定',
    NOTIFICATIONSETTING: "公告栏设定",
    PERSONAL: "个人",
    COMMUNICATION: "沟通",
    COMPANY_SETTING: "公司设定",
    DATA_VIEW: "数据显示",
    CUSTOMER_SERVICE_SETTING: "客户服务设定",
    ACTIVITYTYPES: '活动种类设定',
    SMSVENDOR: 'SMS服务商设定',
    UPGPTSETTING: 'UpGPT设定',
    ASSISTANTSETTINGANDUPLOAD: 'AI 机器人设定',
    GPTTOOLS: '工具箱',
    UPLOADSTATUS: '汇入/上传纪录',
    TREESETTING: '树状选项设定',
    CALENDARSYNC: "行事历同步",
    CUSTOMOPPTYCLOSEDREASON: "自定义商机结案原因",
  },
  CUSTOMOPPTYCLOSEDREASON: {
    ADD: "新增原因",
    ADDREASON: "新增商机结案原因",
    NAME: "结案原因",
    DESCRIPTION: "原因描述",
    SELECTED: "启用",
    ACTIVE: "执行",
  },
  TREESETTING: {
    ADD: '新增选项',
    TS: '树状选项',
    DEL_MSG: '您确定要删除此选项吗?',
    OPEN_ALL: '全部展开',
    CLOSE_ALL: '全部收合',
    NO_OPTION: '至少须有一个选项',
    ERROR: '这选项名称已存在。',
    IS_USING: '此选项使用中，不可删除',
    NO_DATA: '请先新增树状选项',
  },
  UPGPT: {
    BASICSETTING: '基础设定',
    QAUPLOAD: 'Q&A资料上传',
    FOLDERUPLOAD: '文件夹上传',
    FILEUPLOAD: '档案上传',
    UPLOADIMG: '图片上传',
    CLOUD: '云端档案',
    BASICSETTINGSAVE: '储存',
    AIASSISTANTNAME: 'AI 机器人名称',
    AIASSISTANTNAME_TIP1: '设定您 AI 机器人的名称',
    AIASSISTANTNAME_TIP2: '范例: 小安',
    AIASSISTANTROLE: 'AI 机器人角色',
    AIASSISTANTROLE_TIP1: '设定您 AI 机器人所扮演的角色',
    AIASSISTANTROLE_TIP2: '范例: customer service agent (客服人员) for UpDay, a CRM production designed by 安然科技股份有限公司',
    TOPIC: '主题',
    TOPIC_TIP1: '提供 AI 机器人一个主题，使其能更好的改写提问',
    TOPIC_TIP2: '范例: UpDay CRM',
    TOPICLIMIT: '主题限制',
    TOPICLIMIT_TIP1: '如果问题超出主题, AI 机器人会回到应有的主题范围回复',
    TOPICLIMIT_TIP2: '范例: technology',
    RESETDATA: '清空现有知识',
    QAFILEUPLOADMESSAGE: 'Q&A档案需为CSV檔(UTF-8)',
    FOLDERUPLOADMESSAGE: '仅接受压缩文件',
    FILEUPLOADMESSAGE: '仅接受 txt、pdf、docx 及 pptx檔',
    FILEUPLOADMESSAGE_IDP: '仅接受 pdf、docx、xlsx 及 pptx檔',
    DELETEALLDATA: '你确定要重置所有既有信息?',
    WRONGTYPEINZIP: '压缩文件内只能有txt、CSV、pdf、docx、pptx、jpg、jpeg & png檔',
    WRONGTYPEINCSV: 'Q&A档应为CSV檔(UTF-8)',
    WRONGTYPEINFILE: '档案上传仅接受 txt、pdf、docx 及 pptx檔',
    WRONGTYPEINFILE_IDP: '档案上传仅接受 pdf、docx、xlsx 及 pptx檔',
    WRONGTYPEINIMAGEFILE: '图片上传仅接受 JPG、JPEG、PNG 檔',
    WAIT: '请等待档案上传完成后再试一次',
    PREFERENCE_WRONG: '权限设定不完整，请联系管理者',
    AIASSISTANT_KNOWLEDGE_MANAGEMENT: 'AI 机器人知识管理',
    FILE_AMOUNT: '知识库档案总数: ',
    UPDATE_TIME: '最近一次上传时间: ',
    NOFILE: '知识库没有任何档案',
    UPCHAT_INBOX_SETTING: 'UpChat 收件匣设定',
    TIMEOUT_ERROR: '因数据量较多，AI 机器人仍在将其整理成知识库，是否前往"汇入/上传纪录"检视进度?',
    TIMEOUT_ERROR_2: '由於數據量較大 AI 机器人仍在將其整理成知識庫，是否前往查看處理中的文件？',
    EMBEDDING_WRONG: '上传失败，请检查您的CSV文件为UTF-8编码、标头(第一行)的所有字段是否出现双引号(如"XXX")的情形，请去除后再重新上传。也请您检查您的档案是否被加密，请移除加密后在重新上传，如果还是未能上传，请联系UpDay客服人员，谢谢您!',
    UPLOAD_FAIL: '上传失败',
    FILE: '档案',
    DOWNLOAD: '下载',
    DOWNLOAD_TXT: '下载文本文件',
    FILE_HAS_BEEN_DELETED: '档案已被删除，请重整页面',
    WEBSITEANALYSIS: '网站分析',
    WEBSITEANALYSIS_SYNC: '网站分析自动同步',
    WEBSITEANALYSIS_TIP1: '每天凌晨排程，只同步第一层网站数据',
    ADD_URL: '新增网址',
    EDIT_URL: '编辑网址',
    URL: '网址',
    LEVEL: '深度',
    OVERLIMIT: '网址最多只能填写5个',
    ACTION: '执行',
    DELETE_CHECK: '你确定要删除这个网址吗?',
    START_ANALYSIS: '开始分析',
    DOWNLOAD_ZIP: '下载压缩文件',
    BLANK_WEB_INFO: '您需要先进行过分析，才能下载结果',
    NO_URL: '请先填入至少一个网址',
    FILE_TABLE: '已链接知识库档案',
    NOT_CLEAN: '未正确清空，请再清空一次，若还是未能清空，请联系UpDay客服人员，谢谢您!',
    AUTO_DETECT: '自动侦测',
    REPLY_LANGUAGE: '回复语言',
    REPLY_LANGUAGE_TIP: 'AI 机器人会依据所选择的语言回复',
    TIMEOUT_MESSAGE: '因数据量较多，请稍等，是否前往"检视进度"?',
    OVER_SIZE: '上传这些文件夹/文件后，您的存储空间将超出限制。请联系 support@upday.ai 购买更多存储空间或从“已连接知识库档案”中删除一些文件。',
    NOT_ENOUGH_QUOTA: '智能文件分析次数超出限制。请联系 support@upday.ai。',
  },
  ACTIVITYTYPES: {
    ERROR: "此活动类型使用中，不可删除。",
    ERROR_2: "至少须有一个活动类型。",
    ERROR_3: "预设活动类型不可删除。"
  },
  SMSVENDOR: {
    VENDOR: "服务商",
    USER_NAME: "使用者名称",
    USER_PWD: "用户密码",
    DEFAULT: "预设",
    MITAKE: "三竹Mitake",
    DOMAIN: "单笔简讯发送 API URL",
    TIP: "请参考三竹给您的API文件",
    TIP_2: "例 : https://smsapi.mitake.com.tw/api/mtk/SmSend?CharsetURL=UTF8",
  },
  PERSONALSETTING: {
    BOARD_CONTACT_SYNC: '从经济部商业司同步董监事数据为联络人',
    FIRST_NAME: '使用者名称',
    LAST_NAME: '使用者姓氏',
    LANGUAGE: '语言',
    CURRENCY: '币别',
    REGION: '地区',
    OPPTY_DEFAULT_STAGE: '商机默认流程',
    CASE_DEFAULT_STAGE: '案件默认流程',
    INBOX_NOTIFICATION_SETTINGS: 'Inbox 通知设定',
    ERROR: '请选择图档',
    ERROR_2: '照片请小于5MB',
  },
  PASSWORDANDLOGIN: {
    TITLE: '变更密码',
    TITLE_2: '重设密码',
    MESSAGE: '为了您的账户安全，请定时更改密码。并增加密码复杂程度，不要使用容易猜测的字符串。例：生日、电话...等',
    ERROR: '请确认密码长度为8-30个字且包含大写小写英文字母、数字、特殊符号',
    ERROR_2: '输入密码不符合新密码，或密码格式错误',
    ERROR_3: '请填入目前密码',
    ERROR_4: '新密码和确认密码为必填',
    ERROR_5: '请重新确认输入密码',
    ERROR_6: '修改密码失败, 请重试',
    ERROR_7: '新密码和确认密码不同, 请重新输入',
    ERROR_8: '重设密码失败, 请重试.  厡因:',
    ERROR_9: '此重设密码链接已失效',
    OLD_PASSWORD: '目前密码',
    NEW_PASSWORD: '新密码',
    NEW_PASSWORD_2: '确认密码',
  },
  EMAILSYNC: {
    TEXT: '连结账户',
    TEXT_2: '以下显示您已链接之M365账户',
    NO_CONNECT: '尚无连结账户',
    ADD_ACCOUNT: '新增账户',
    MESSAGE: '您确定要删除此M365账号设定吗？',
    ERROR: '删除失败, 请重试',
    DIALOG: '连结M365账户',
    DIALOG_2: '点击新增按钮，将为您导至M365登入页面。连结成功后，将为您导回此设定页面。',
    DIALOG_S: '成功连结M365账户',
    DIALOG_S2: '您已成功连结M365账户。请在电子邮件同步部分验证您的帐户电子邮件地址。谢谢！',
    START_SYNC: "开始同步",
    SYNCING: "同步中",
    H1: "Email同步处理：",
    H1_1: "所有Email皆同步至UpDay",
    H1_2: "只有指定电邮同步至UpDay",
    H1_3: "开启",
    H1_4: "关闭",
    H2: "从何时开始同步：",
    H2_1: "今天",
    H2_2: "1个月内",
    H2_3: "3个月内",
    H2_4: "6个月内",
    H2_5: "自定义",
    H3: "同步寄送与寄出的Email对象：",
    H3_1: "只有UpDay联络人",
    H3_2: "所有人",
    H4: "Email 限制设定：",
    H5: "设定黑名单Email或网域",
    H6: "黑名单Email",
    H7: "黑名单网域",
    H8: "可接受网域",
    TOO_MUCH_INBOX: "收件匣中的信件数量超过9999，请选择较少同步时间范围后再试一次。",
    TOO_MUCH_SENTBOX: "发件箱中的信件数量超过9999，请选择较少同步时间范围后再试一次。",
  },
  EMAILTEMPLATE: {
    TEMPLATE: '范本',
    ADD_TEMPLATE: '新增范本',
    EDIT_EMAIL_TEMPLATE: '修改Email范本',
    ADD_EMAIL_TEMPLATE: '新增Email范本',
    NAME: '模板名称',
    SUBJECT: '主旨',
    //Header
    ADD_DATE: '建立时间',
    END_TIME: '最后修改时间',
    ACTIVE: '执行',
    MESSAGE: '您确定要删除吗？',
    ERROR: '请填入新增模板名称!',
  },
  SMSTEMPLATE: {
    TEMPLATE: '范本',
    ADD_TEMPLATE: '新增范本',
    EDIT_SMS_TEMPLATE: '修改SMS范本',
    ADD_SMS_TEMPLATE: '新增SMS范本',
    NAME: '模板名称',
    //Header
    ADD_DATE: '建立时间',
    END_TIME: '最后修改时间',
    ACTIVE: '执行',
    MESSAGE: '您确定要删除吗？',
  },
  MANAGEUSERS: {
    RESET_PASSWORD: '重置密码',
    RESET_LINK_DESC: '请将以下重置密码链接提供给用户：',
    RESET_LINK_ERROR: '无法生成重置密码链接，请稍后再试。',
    INVITED_TITLE: '用户已创建',
    INVITED_DESC: '请将以下账号与密码提供给用户。关闭后将无法再次查看密码。',
    INVITED_USERNAME: '账号',
    INVITED_PASSWORD: '密码',
    USERMANAGER: "主管",
    SEAT: '可用空位',
    ACTIVATED: '启用',
    UNACTIVATED: '未启用',
    INVITE_USERS: '邀请使用者',
    MANAGER: '管理者',
    STAFF: '员工',
    MAIL_TITLE: "Email",
    MAIL: 'Email 将作为登入账号使用',
    USER: '用户',
    FIRST_NAME: '使用者名称',
    LAST_NAME: '姓氏',
    USER_ROLE: '身份',
    INVITE: '送出邀请',
    EDIT_USER: '编辑使用者',
    //Header
    NAME: '名称',
    ROLE: '角色',
    IS_SERVICE_AGENT: '客服人员',
    IS_TECH_USER: '技术人员',
    IS_PORTAL_USER: 'Portal 使用者',
    IS_PORTAL_USER_ADD: '設定為Portal 使用者',
    IS_VIEW_ONLY_USER: '只读人员',
    LAST_TIME: '最后登入时间',
    ACTIVE: '执行',
    MESSAGE: '您确定要停用此用户吗？',
    MESSAGE_2: '您确定要重启此用户吗？',
    ERROR: '抱歉，使用者人数已达上限！如需新增，请将现有联络人设为未启用。',
    ERROR_2: '抱歉，您的权限不足！',
    ERROR_3: '账号已存在。',
    ERROR_4: '至少需有一位管理者',
  },
  MANAGEGROUPS: {
    ADD_GROUP: '新增团队',
    ADD_GPT_GROUP: '新增团队',
    EDIT_GPT_GROUP: '编辑团队',
    GROUP: '团队',
    NAME: '名称',
    TYPE: '类型',
    MEMBER: '成员',
    NAME_HINT: '名称不可重复',
    TYPE_HINT: '此栏位为必填',
    MEMBER_HINT: '团队至少须有一位成员',
    //Header
    ACTIVE: '执行',
    ERROR: '抱歉，您的权限不足！',
    ERROR_2: '这团队名称已存在。',
    MESSAGE: '您确定删除要此团队吗？',
    MEMBER_SEARCH: '搜索成员',
  },
  CUSTOMFIELDS: {
    SELECT_PROCESS: '选择流程',
    SELECT_PAGE: '选择页面',
    ADD_FIELD: '新增字段',
    EDIT_OPTION: '编辑选项',
    OPTION: '选项',
    TREE_OPTION: '树状选项',
    ADD_CF: '新增自定义字段',
    P_SELECT_PAGE: '请选择使用页面',
    SELECT_O_PROCESS: '选择商业流程',
    SELECT_C_PROCESS: '选择案件流程',
    SELECT_MESSAGE: '选择一个或多个字段至窗体',
    NAME: '域名',
    TYPE: '字段类型',
    DESCRIPTIONS: '字段描述',
    MANDATORY: '是否必填',
    //Header
    ACTIVE: '执行',
    NO_OPPTY_STAGE: '尚无商业流程',
    NO_CASE_STAGE: '尚无案件流程',
    ERROR: '请至少保留两个选项',
    ERROR_2: '请输入正确内容',
    ERROR_3: '请至少输入两个选项',
    ERROR_4: '请先新增商业流程',
    ERROR_5: '请先新增案件流程',
    ERROR_6: '请输入新选项内容，并按下Enter',
    MESSAGE: '您确定要删除吗？',
  },
  TABLESETTING: {
    PAGE: '选择页面',
    PROCESS: '选择流程',
    NEW: '新增数据表',
    COPY: '复制当前数据表',
    DEFAULT: '预设',
    NAME: '名称',
    MESSAGE: "您确定要删除此数据表吗？",
    SET: '设定',
    FIELD: '字段',
    SEQ: '排序',
    TITLE: '编辑当前数据表',
  },
  FILTERSETTING: {
    FILTER: '筛选',
    ADD: "新增筛选",
    EDIT: "编辑筛选",
    COPY: "复制筛选",
    VISIBILITY: "隐私设定",
    VISIBILITY_0: "私人",
    VISIBILITY_1: "公开",
    DEFAULT: '预设',
    FILTERFIELD: "选择字段",
    PERSONAL_SETTING: '个人设定',
    SYSTEM_SETTING: '系统设定',
    CONDITION: "选择条件",
    ADD_CONDITION: "新增条件",
    DATE: "选择日期",
    CAMPAIGN: '选择相关活动',
    SEG: '选择相关分群',
    PRODUCT: '选择产品',
    PARENT_CASE: '选择母案件',
    TEXT: "填入文字",
    NUM: "填入数字",
    OPT: "选择选项",
    TRUE: "是",
    FALSE: "否",
    INPUT_TO_SEARCH: '请输入公司名称进行搜寻',
    INPUT_CONTACT_TO_SEARCH: '请输入联络人名称进行搜寻',
    INPUT_PRODUCT_TO_SEARCH: '请输入产品名称进行搜寻',
    INPUT_PARENT_CASE_TO_SEARCH: '请输入母案件名称进行搜寻',
    ERROR: '请至少新增一项条件',
    ERROR2: '请选择字段',
    ERROR3: '请确认搜寻条件',
    MESSAGE: '您确定要删除此筛选吗？',
    PUBLIC: '公开',
    PRIVATE: '私人',
    CS: '自定义选项',
    NO_FILTER: '无筛选',
    DELETED_DATA: '已被删除的数据',
  },
  OP_TEXT: {
    CONTAINS: "包含",
    NOT_CONTAINS: "不包含",
    IS_EMPTY: "为空",
    NOT_EMPTY: "不为空",
  },
  OP_NUM: {
    EQUAL: "等于",
    EQUAL_LESS: "小于等于",
    EQUAL_LARGER: "大于等于",
    LESS: "小于",
    LARGER: "大于",
  },
  OP_DATE: {
    ON: "等于",
    ON_OR_AFTER: "等于 或 之后",
    ON_OR_BEFORE: "等于 或 之前",
    TODAY: "今天",
    YESTERDAY: "昨天",
    TOMORROW: "明天",
    NEXT_7_DAYS: "接下来7天",
    LAST_7_DAYS: "之前7天",
    THIS_WEEK: "本周",
    THIS_MONTH: "本月",
    THIS_QUARTER: "本季",
    THIS_YEAR: "今年",
    NEXT_WEEK: "下周",
    NEXT_MONTH: "下个月",
    NEXT_QUARTER: "下一季",
    NEXT_YEAR: "明年",
    LAST_WEEK: "上周",
    LAST_MONTH: "上个月",
    LAST_QUARTER: "上一季",
    LAST_YEAR: "去年",
  },
  PIPELINESTAGESETTING: {
    ADD: '新增流程',
    WORRY: '不用担心您的团队没有按照商业流程或是SOP！只要您在此设定好商业流程，系统将会引导您的团队迈向更好的结果。',
    ERROR: '此流程已有商机使用，请更换流程后再行删除。',
    ERROR_2: '此流程已有案件使用，请更换流程后再行删除。',
    MESSAGE: '您确定要删除吗？',
    DEFAULT_PROCESS: '系统默认流程'
  },
  CUSTOMERSERVICESETTING: {
    ADD: '新增选项',
    TYPE: '案件类型',
    GROUP: '案件组别',
    CATEGORY: '案件分类',
    ADD_OPTION: '新增客户服务选项',
    USEING_TYPE: '请选择使用类型',
    NAME: '选项名称',
    OPTION_DESCRIPTION: '选项描述',
    //----TAB
    ACTIVE: '执行',
    MESSAGE: '您确定要删除吗？',
    ERROR_1: "此案件组别正在使用中",
    ERROR_2: "此案件类型正在使用中",
  },
  KNOWLEDGEARTICLESUBJECTSETTING: {
    ADD_SUBJECT: '新增主题',
    ADD: '新增知识库文章主题',
    NAME: '主题名称',
    DESCRIPTION: '主题描述',
    ACTIVE: '执行',
    MESSAGE: '确定要删除此主题吗？',
  },
  AUTONUMBERSETTING: {
    CASE_SETTING: '案例设定',
    PERFIX: '前缀字符',
    SUFFIX: '后缀字符',
    RECODR_TYPE: '纪录类型',
    NUMBER_FORMAT: '数字格式',
    START_NUMBER: '起始号码',
    CURRENT_NUMBER: '目前号码',
    RESET: '重置目前号码',
    ACTIVATED: '启用',
    UNACTIVATED: '停用',
    KA_SETTING: '知识文章设定',
    TIME_MODE: '时间模式',
    NUMBER_MODE: '数字模式',
    NO_RECORD: '尚无纪录',
    MESSAGE: '目前号码小于起始号码，是否重置目前号码？',
    RULE: '字数请限制在',
    RULE_1: '字内',
    AUTO: '自动填入标题',
  },
  PRODUCTSETTING: {
    TYPE: '产品类型',
    DP: '一般产品',
    SP: '服务型产品',
    LP: '产品型产品',
    PRODUCT: '产品',
    CATEGORY: '类别',
    SERIES: '系列',
    NAME: '名称',
    PRODUCTCODE: '序号',
    PRICR: '定价',
    COST: '成本',
    DESCRIPTIONL: '描述',
    ADD_PRODUCT: '新增产品',
    EDIT_PRODUCT: '修改产品',
    ADD_PRODUCT_2: '新增产品类别',
    EDIT_PRODUCT_2: '修改产品类别',
    ADD_PRODUCT_3: '新增产品系列',
    EDIT_PRODUCT_3: '修改产品系列',
    MESSAGE: '您确定要删除吗？',
    ERROR: '此商品正在使用中',
    ERROR_2: '此类别正在使用中',
    ERROR_3: '此系列正在使用中',
  },
  NOTIFICATIONSETTING: {
    ADD_NOTICE: "新增",
    NOTICE: "公告",
    NOTICEBOARD: "公告栏",
    TITLE: "标题",
    CONTENT: "内容",
    STATUS: "状态",
    ACTIVE: "执行",
    MESSAGE: "您确定要删除此公告吗？",
    MESSAGE2: "您确定吗？下一次登入将再次显示。",
    ACTIVATED: "启用",
    UNACTIVATED: "停用",
    ERROR: "此公告标题已存在。",
    TIMER: "公告转动时间",
    SECONDTIMES: "秒/次"
  },
  INBOX_NOTIFICATION_SETTINGS: {
    ALLOW_WEB_PUSH: "允许开启网页推播",
    ALLOW_FOLLOW: "在我追踪的纪录变更时提醒我",
    ALLOW_MENTION: "在我被@提及时提醒我",
    ALLOW_REPLY: "在我订阅的贴文有人回复时提醒我",
    ALLOW_EMOJI: "在我订阅的贴文有人喜欢时提醒我",
  },
  CALENDAR_SYNC_SETTINGS: {
    SELECT_CALENDAR: "选择行事历",
    SYNC_TYPE: "同步模式",
    SYNC_AS: "同步为",
    PRIVATE_EVENTS: "私人活动",
    SELECT_TO_SYNC: "要同步的活动类型",
    SYNC_REGARDING: "同步相关资料",
    PRIVATE_EVENTS_0: "不同步",
    PRIVATE_EVENTS_1: "同步",
    SYNC_REGARDING_0: "不包含相关资料",
    SYNC_REGARDING_1: "包含相关资料",
    NO_SELECT_TYPE: "尚未选择",
    STOP_SYNC: "停止同步",
    CONNECT_SUCCESS: "您已成功连结M365账户。请在行事历同步页面验证您的帐户电子邮件地址。谢谢！",
    SYNC_TYPE_ONE_0: "单向同步",
    SYNC_TYPE_ONE_1: "UpDay活动同步至M365行事历",
    SYNC_TYPE_ONE_2: "仅更改UpDay活动同步至UpDay活动",
    SYNC_TYPE_TWO_0: "双向同步",
    SYNC_TYPE_TWO_1: "UpDay活动同步至M365行事历",
    SYNC_TYPE_TWO_2: "M365行事历同步至UpDay活动",
  },
  //--------Common DIALOG
  CHANGEOWNER: {
    TITLE: '变更客服人员',
    TITLE_2: '变更文章作者',
    TITLE_3: '变更拥有者',
  },
  CASECARD: {
    TITLE: '案件',
    NO_CASE: '尚无案件',
    CASE_NUMBER: '案件编号',
  },
  PRODUCTTABLE: {
    NO_PRO: '尚无产品',
    MESSAGE: '您确定要删除此产品吗？',
  },
  PRODUCTLINEITEM: {
    QUANTITY: '数量',
    QUANTITY_H: '数量',
    QUANTITY_D: '总数量',
    DAYS: "天数",
    TAX: '税',
    TAX_H: '税',
    UNIT: '单位',
    DISCOUNT: '折扣',
    DISCOUNT_H: '折扣',
    AMOUNT: '金额',
    AMOUNT_H: '金额',
    SUBTOTAL_LIST_PRICE: '定价小计',
    TOTAL_DISCOUNT: '折扣小计',
    SUBTOTAL_AMOUNT: '金额小计',
    SALES_TAX: '销售税额',
    TOTAL: '总计 ',
    TOTAL_PRODUCTS: '商品总数',
    TAX_INCLUSIVE: '金额含税',
    TAX_EXCLUSIVE: '金额未税',
    NO_TAX: '不计税',
    SYSTEM_COMPUTE: '系统计算',
    MANUAL_INPUT: '手动输入',
    DISCOUNT_DATA: '折扣',
    TAX_DATA: '税额',
    OTHER_CHARGES: '其他费用',
    ENABLE_TRQ: '时间区间',
    FROM: '起始日期',
    TO: '结束日期',
    FROMTOERROR: '不可只填单一日期',
    OC_DISCOUNT: '其他费用小计',
    OC: '其他费用',
  },
  CASETABLE: {
    NO_CASE: '尚无案件',
    MESSAGE: '您确定要删除此案件吗？',
    SUBJECT: '主题',
    CONTACT: '联络人',
    PRIORITY: '优先等级',
    STATUS: '状态',
    GROUP: '组别',
    TYPE: '类型',
    OWNER: '客服人员',
    CLOSED_DATE: '结案日期',
  },
  OPPTYCARD: {
    TITLE: '商机',
    NO_OPPTY: '尚无商机',
    EXPECTED_CLOSE_DATE: '预期结案日期',
  },
  CUSTOMFIELD: {
    TITLE: '自定义字段',
    NO_DATA: '尚无自定义字段',
  },
  EMAILEDITOR: {
    RECIPIENT: '收件人',
    COPY: '副本',
    ATTACHMENT: '附件',
    SUBJECT: '主旨',
    SEND: '寄出',
    CLEAR: '清除',
    TEMPLATE: 'Email 范本',
    NO_O365: '您还未设定您的M365账号。如果要寄送电邮，请至设定>Email同步设定M365账号。谢谢！',
    INVALID_O365_TOKEN: '您的设置M365账号长时间未使用。请转到设定>Email同步删除现有的M365账号并重新设置。谢谢！',
    NO_DATA: '尚无资料',
    GO_SETTING: '前往设定',
    ERROR: '附件档案总共不能超过20MB',
    ERROR_2: '此电邮地址格式不正确',
    ERROR_3: '寄送电邮之前请先填妥字段',
  },
  SMSEDITOR: {
    ADD: '新增',
    RECIPIENT: '收件人',
    NUMBER: '收件号码',
    ENTER: '输入手机号码',
    SEND: '传送',
    CLEAR: '清除',
    TEMPLATE: 'SMS 范本',
    ERROR: '寄送简讯之前请先填妥字段',
    ERROR_2: '请输入正确格式',
  },
  LOSEREASON: {
    TITLE: '客服案件结案',
    TITLE_2: '选择失败原因',
    TITLE_3: '确认赢得商机',
    CASE_NAME: '案件名称',
    CONTACT_NAME: '主要联络人名称',
    OPPTY_NAME: '商机名称',
    CUSTOMER_NAME: '客户名称',
    CLOSE_DATE: '结案日期',
    CLOSE_REASON: '结案原因',
    STATUS: '状态',
    CLOSED: '已结案',
    OPEN: '进行中',
    AMOUNT: '金额',
    LOSE: '失败原因',
    WIN: '赢得商机',
  },
  EMAILCAMPAIGNDIALOG: {
    TITLE: 'Email 预览',
    SUBJECT: '主旨',
    ATTACHMENT: '附件',
    MESSAGE: 'Email寄送中，点选确认前往活动页面查看寄送进度'
  },
  SMSCAMPAIGNDIALOG: {
    TITLE: 'SMS 预览',
    SMS_CONTENT: '简讯内容',
    MESSAGE: '简讯寄送中，点选确认前往活动页面查看寄送进度'
  },
  ADDPROCESSDIALOG: {
    EDIT: '编辑流程',
    ADD_OPPTY: '新增商业流程',
    ADD_CASE: '新增案件流程',
    NAME: '流程名称',
    PAGE: '流程使用页面',
    STAGE_NAME: '阶段名称',
    PROBABILITY: '商机赢得机率',
    FINISH_DAY: '预期完成天数',
    GUIDE: '成功指引',
    COLOR: '颜色',
    DAY: '天',
    ERROR: '阶段不可为空',
    ERROR_2: '此步骤已有使用纪录，故无法删除。',
    MESSAGE: '您确定要删除步骤吗？'
  },
  ADDNOTE: {
    TITLE: '新增备注',
    TITLE_2: '修改备注',
    CONTENT: '请输入备注内容',
  },
  EMAILATTACHMENTSDIALOG: {
    TITLE: '电邮附件',
  },
  EMAILCONTACTSDIALOG: {
    TITLE: '关联联络人',
  },
  EMAILOPPTIESDIALOG: {
    TITLE: '关联商机',
    NO_OPPTY: '尚无关联商机',
    EXPECTED_CLOSE_DATE: '预期结案日期 : ',
  },
  REDIRECTDIALOG: {
    NEW_CONTACT: '查看新联络人',
    NEW_ORG: '查看新公司',
    NEW_OPPTY: '查看新商机',
    NEW_CASE: '查看新案件',
    NEW_ORDER: '查看新订单',
    NEW_CONTRACT: '查看新合约',
  },
  //------- List.js
  LEVELLIST: { 0: "职员", 1: "经理", 2: "董事", 3: "C-Level", 4: "所有者" },
  KASTATUSLIST: {
    PUBLISHED: '已发布',
    WAIT_PUBLISH: '等待发布',
    IN_REVIEW: '审查中',
    AUTHORING: '撰写中',
  },
  CASESTATUSLIST: {
    OPEN: '进行中',
    PENDING: '待办中',
    WAIT_CUSTOMER: '等待客户',
    WAIT_3RD_PARTY: '等待第三方',
    RESOLVED: '已解决',
    CLOSED: '关闭',
  },
  OPPTYSTATUSLIST: {
    OPEN: '进行中',
    WON: '赢得商机',
    LOSE: '商机失败',
  },
  CAMPAIGNTYPELIST: {
    ADVERTISEMENT: '广告',
    DIRECT_MARKETING: '直接营销',
    MARKETING_EVENT: '事件营销',
    JOINT_MARKETING: '合作营销',
    OTHERS: '其他',
  },
  CASEPRIORITYLIST: {
    VERY_HIGH: '最高',
    HIGH: '高',
    MEDIUM: '中',
    LOW: '低',
    VERY_LOW: '最低',
  },
  CASESOURCELIST: {
    EMAIL: '电邮',
    WEB_FORM: '网络窗体',
    WEB_CHAT: '在线客服',
    PHONE: '电话',
    STORE: '实体店',
    OUTBOUND: '外拨',
    OTHERS: '其他',
  },
  CLOSECASEREASONLIST: {
    RESOLVED: '解决',
    ALTERNATIVE: '替代解决方案',
    NO_SOLUTION: '无解决方案',
    NO_RESPONSE: '客户无响应',
    NOT_AN_ISSUE: '非问题',
  },
  CLOSEREASONLIST: {
    null: '进行中商机',
    0: '重启商机',
    1: '赢得商机',
    2: '抢输竞争对手',
    3: '对方不做事',
  },
  NUMBERTYPELIST: {
    3: '三位数',
    4: '四位数',
    5: '五位数',
    6: '六位数',
    7: '七位数',
    8: '八位数',
    9: '九位数',
    10: '十位数',
    11: '十一位数',
    12: '十二位数',
    13: '十三位数',
    14: '十四位数',
    15: '十五位数',
  },
  SEGMENT_TYPELIST: {
    STATIC: '固定分群',
    DYNAMIC: '动态分群',
  },
  STAGEDEFCOLORLIST: {
    0: '红色',
    1: '橘色',
    2: '黄色',
    3: '绿色',
    4: '蓝色',
    5: '紫色',
  },
  INDUSTRYLIST: {
    0: '农、林、渔、牧业',
    1: '矿业及土石采取业',
    2: '制造业',
    3: '电力及燃气供应业',
    4: '用水供应及污染整治业',
    5: '营建工程业',
    6: '批发及零售业',
    7: '运输及仓储业',
    8: '住宿及餐饮业',
    9: '出版影音及资通讯业',
    10: '金融及保险业',
    11: '不动产业',
    12: '专业、科学及技术服务业',
    13: '支持服务业',
    14: '公共行政及国防；强制性社会安全',
    15: '教育业',
    16: '医疗保健及社会工作服务业',
    17: '艺术、娱乐及休闲服务业',
    18: '其他服务业',
  },
  ORGTYPELIST: {
    0: '外国公司之分公司',
    1: '外国公司之办事处',
    2: '本地公司设立之分公司',
    3: '合作社',
    4: '合伙',
    5: '有限公司',
    6: '有限合伙',
    7: '两合公司',
    8: '其他',
    9: '股份有限公司',
    10: '无限公司',
    11: '独资',
  },
  AGENTSTATUSLIST: {
    ONLINE: '在线',
    AWAY: '离开',
    BUSY: '忙碌',
    OFFLINE: '脱机',
  },
  CONTACTSFIELDLIST: {
    created_on: '建立时间',
    created_by: '建立者',
    updated_on: '更新时间',
    updated_by: '更新者',
    owner: '拥有者',
    orgs: '公司名称',
    full_name: '联络人姓名',
    english_full_name: '(英)联络人姓名',
    english_title: '(英)职称',
    english_department: '(英)部门',
    invoice_recieved: '发票接收',
    mailing_address: '地址2',
    total_amount: '进行商机总额',
    title: '职称',
    email: '电子邮件',
    mobile_phone: '移动电话',
    office_phone: '连络电话',
    description: '描述',
    department: '部门',
    birthdate: '生日',
    level: '级别',
    fax: '传真',
    facebook: 'Facebook',
    linkedin: 'Linkedin',
    instagram_id: 'Instagram',
    line_id: 'Line',
    billing_address: '地址',
    city: '城市',
    country: '国家',
    zip_code: '邮政编码',
    province: '省分',
    primary_campaign_id: '相关活动',
    seg: '分群'
  },
  ORGSFIELDLIST: {
    created_on: '建立时间',
    created_by: '建立者',
    updated_on: '更新时间',
    updated_by: '更新者',
    owner: '拥有者',
    name: '公司名称',
    website: '网站',
    company_number: '统一编号',
    main_phone: '电话',
    description: '描述',
    industry: '行业别',
    employee: '员工人数',
    establish_date: '成立日期',
    annual_revenue: '营业额',
    registered_capital: '资本额',
    fax: '传真',
    billing_address: '地址',
    sub_address: '地址2',
    city: '城市',
    country: '国家',
    zip_code: '邮政编码',
    province: '省分',
    total_amount: '进行商机总额',
    organization_type: '类型',
    primary_campaign_id: '相关活动',
    name_en: '(英) 公司名称',
    closing_date: '关帐日',
    payment_term: '付款条件',
    regular_payment_date: '固定付款日',
    belong_group: '所属集团',
  },
  OPPTYSFIELDLIST: {
    created_on: '建立时间',
    created_by: '建立者',
    updated_on: '更新时间',
    updated_by: '更新者',
    owner: '商机拥有者',
    name: '商机名称',
    amount: '金额',
    expected_close_date: '预期结案日期',
    closed_date: '结案日期',
    closed_reason: '结案原因',
    status: '状态',
    forecast_category: '预测类别',
    customer_needs: '客户需求',
    customer_budget: '客户预算',
    budget_confirmed: '确认预算',
    primary_campaign_id: '相关活动',
    stage_type: '商业流程',
    oppty_contact: '客户名称',
    current_stage: '现在阶段',
    primary_contact: '主要联络人',
    description: '描述',
    filter_oppty_contact: '客户名称（联络人）',
    filter_oppty_org: '客户名称（公司）',
    tax_option: '计税方式',
  },
  CASESFIELDLIST: {
    created_on: '建立时间',
    created_by: '建立者',
    updated_on: '更新时间',
    updated_by: '更新者',
    owner: '客服人员',
    subject: '标题',
    case_number: '案件编号',
    due_date: '预期结案日',
    incoming_fullname: '进线联络人',
    incoming_phone: '进线电话',
    incoming_email: '进线电邮',
    source: '案件来源',
    status: '状态',
    closed_date: '结案日期',
    closed_reason: '结案原因',
    priority: '优先等级',
    primary_campaign_id: '相关活动',
    primary_contact: '联络人',
    case_org: '公司',
    group: '组别',
    type: '类型',
    stage_type: '案件流程',
    current_stage: '阶段',
    description: '案件描述',
    resolution: '案件处理',
    product: '产品',
    parent_case_id: '母案件',
  },
  CASEDASHBOARD: {
    TITLE: '客服案件仪表板',
    UNSOLVED: '未解决',
    OVERDUE: '过期',
    DUE_TODAY: '今日到期',
    CLOSED: '已结案',
    OPEN: '进行中',
    ON_HOLD: '等待中',
    HIGH_PRIORITY: '高优先等级',
    AVERAGE_RESOLVED_TIME: '平均处理时间',
    DAY: '天',
    HOUR: '小时',
    MIN: '分钟',
    PRIORITY: '优先等级',
    SOURCE: '进线来源',
    GROUP: '组别',
    TYPE: '类型',
    PROCESS: '处理流程',
    LINE_CHART: '案件折线图',
    RECEIVED: '受理案件',
    RESOLVED: '解决案件',
    CASE_RANKING: '案件处理排行',
    CASES: '件',
    UP: '上升',
    DOWN: '下降',
    AGENT_STATUS: '客服人员状态',
    AGENT_TOTAL: '客服人员总数'
  },
  UPCHATDASHBOARD: {
    TITLE: '聊天互动仪表板',
  },
  CAMPAIGNSTAUSLIST: {
    PROPOSED: '已提案',
    READY_TO_ACTIVATE: '准备启动',
    ACTIVATED: '已启动',
    COMPLETED: '已完成',
    CANCELLED: '已取消',
    SHELVED: '搁置',
    NOT_IN_USE: '非使用中',
  },
  IMPORT_EXPORT: {
    TITLE: '汇入数据',
    TITLE_2: '导出资料',
    IMPORT: '汇入',
    EXPORT: '汇出',
    PAGE: '页面',
    DATATYPE: '导出资料',
    STAGE: '流程',
    DOWNLOAD: '下载',
    TEMP: '范本',
    DB_DATA: '所有数据',
    SELECT: '选择档案',
    NOTICE: '注意事项',
    DOWNLOAD_TEMP: '下载汇入范本',
    ERROR: '本浏览器不支持导出功能, 建议使用Chrome或Edge',
    CONTACT_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner字段时，姓名中间请以空格分开，如：陈 振凯\n3. Company Name、Campaign字段内容不存在时，将自动建立\n4. 自定义域名若有重复，或与现有域名相同时，数据会被覆盖\n5. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n6. 填入日期时，请以yyyy-mm-dd格式输入',
    ORG_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner字段时，姓名中间请以空格分开，如：陈 振凯\n3. Campaign字段内容不存在时，将自动建立\n4. 自定义域名若有重复，或与现有域名相同时，数据会被覆盖\n5. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n6. 填入日期时，请以yyyy-mm-dd格式输入',
    OPPTY_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner、Oppty Contact、Primary Contact字段时，姓名中间请以空格分开，如：陈 振凯\n3. Oppty Org、Oppty Contact、Primary Contact、Campaign字段内容不存在时，将自动建立\n4. 自定义域名若有重复，或与现有域名相同时，数据会被覆盖\n5. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n6. 填入日期时，请以yyyy-mm-dd格式输入\n7. 请勿更改Stage Type，并确认Current Stage填写正确',
    CASE_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner、Primary Contact字段时，姓名中间请以空格分开，如：陈 振凯\n3. Primary Contact、Case Org、Campaign、Group、Type字段内容不存在时，将自动建立\n4. 自定义域名若有重复，或与现有域名相同时，数据会被覆盖\n5. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n6. 填入日期时，请以yyyy-mm-dd格式输入\n7. 请勿更改Stage Type，并确认Current Stage填写正确\n8. Case Number字段未填写时，将依照流水号设定自动建立',
    KA_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner字段时，姓名中间请以空格分开，如：陈 振凯\n3. Subject字段内容不存在时，将自动建立\n4. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n5. Content字段，请以HTML格式填写\n6. Article Number字段未填写时，将依照流水号设定自动建立',
    PRODUCT_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner字段时，姓名中间请以空格分开，如：陈 振凯\n3. Category、Series字段内容不存在时，将自动建立\n4. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n5. 填入日期时，请以yyyy-mm-dd格式输入',
    ORDER_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner、Contact字段时，姓名中间请以空格分开，如：陈 振凯\n3. Organization字段内容不存在时，将自动建立\n4. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n5. 填入日期时，请以yyyy-mm-dd格式输入',
    LICENSE_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner、Contact、Contact2、Contact3字段时，姓名中间请以空格分开，如：陈 振凯\n3. Contact、Contact2、Contact3、Organization、Product字段内容不存在时，将自动建立\n4. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n5. 填入日期时，请以yyyy-mm-dd格式输入',
    SERVICE_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 填入Owner、Contact、Contact2、Contact3字段时，姓名中间请以空格分开，如：陈 振凯\n3. Contact、Contact2、Contact3、Organization、Product字段内容不存在时，将自动建立\n4. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n5. 填入日期时，请以yyyy-mm-dd格式输入',
    FLEXFIELD_LABEL: '注意事项\n1. 若有填入ID字段，数据将会更新\n2. 请确认填入内容符合该字段格式 \n3. 数据内容出现科学记号时，请于Excel中调整单元格格式，避免数据储存错误\n4. 填入日期时，请以yyyy-mm-dd格式输入',
    COPY: '复制讯息',
    ERROR_2: '请确认汇入档案内容，或使用模板填写数据',
    ERROR_3: '因数据笔数较多，系统仍于背景执行汇入程序，若数据尚未完整汇入，请耐心等候并重新整理页面',
    COPY_2: '已复制',
    SEARCH: '搜寻字符串',
    ING: '处理中',
    OPPTY_PRODUCT: '导出商机产品',
    PROGRESS: '目前进度 : ',
    STILL_RUN: '汇入作业进行中，是否前往"汇入/上传纪录"检视进度?',
  },
  UPCHAT: {
    TITLE: '讯息纪录',
    SENDER: '寄送者 : ',
    SENDER_B: '寄送者 : 机器人',
    ROBOT: '机',
    NO_MESSAGE: '尚无对话纪录',
    SHOW: '显示讯息',
    CHANNEL: '讯息来源',
    BLANK: '请点击对话以显示联络人信息',
    NO_AGENT: '未指派客服人员',
    SYNC: '您确定要同步此联络人吗？',
    CIC: 'UpDay 客户互动中心',
  },
  DOCUMENT: {
    TITLE: '档案',
    NO_DOC: '尚无档案',
    NAME: '名称',
    DESCRIPTION: "描述",
    CREATE: '建立时间',
    UPDATE: '修改时间',
    ADD: '新增档案',
    EDIT: '修改档案',
    DEL: '删除档案',
    NEW_FILE: '选择新档案',
    MESSAGE_DEL: '您确定要删除此档案吗？',
    MESSAGE_DEL_2: '您确定要删除这些档案吗？'
  },
  END_CUSTOMER: {
    TITLE: '终端客户',
    ADD: '新增资料',
    EDIT: '编辑数据',
    NO_DATA: '尚无资料',
    DEL: '您确定要删除此终端客户吗？',
    NAME: '终端客户名称',
  },
  BULK_EDIT: {
    TITLE: '批量修改',
    CHANGE_STAGE: '更新流程',
    MESSAGE: `确定要更新以下案件吗？`,
    MESSAGE_CONTACT: '确定要更新以下联络人吗？',
    MESSAGE_OPPTY: '确定要更新以下商机吗？',
    MESSAGE_ORG: '确定要更新以下公司吗？',
    MESSAGE_DATA: '确定要更新已选取的 ',
    MESSAGE_DATA_2: ' 笔资料吗？',
    MESSAGE_EMPTY: '请选择要更新的数据',
    ERROR_CASE: '以下案件已结案，如需批量修改，请将结案原因设为空值。',
    ERROR_DEAL: '以下商机已结案，如需批量修改，请更新结案原因并选择重启商机。',
  },
  BULK_EDIT_LIST: {
    0: '维持原数据',
    1: '更新数据',
    2: '设为空值',
  },
  INBOX: {
    SEND: '送出',
    TITLE: '留言板',
    UNREAD: '未读',
    ALL: '全部',
    POST: '贴文',
    ALERT: '提示',
    FOCUS: '提示贴文',
    NWE_POST: '新增贴文',
    SUBSCRIBE: '订阅',
    UNSUBSCRIBE: '取消订阅',
    READ_MORE: '显示全部内容',
    READ_LESS: '显示部分内容',
    DELETE: "您确定要删除此贴文吗？",
    DELETE_ALERT: "您确定要删除此提示吗?",
    CONTENT_EMPTY: "内容空白!",
    CONTENT_NOT_EMPTY: "如果关闭，你将失去已撰写的内容。 你确定要关闭吗?",
    FILE_LIMIT: "上传档案总量大小不可超过20MB",
    ALL_READ: "标示全部为已读",
    ALL_DELETE: "删除全部贴文",
    ALL_DELETE_CHECK: "您确定要删除您所有的贴文吗？",
    ALL_DELETE_ALERT: "删除全部提示",
    ALL_DELETE_ALERT_CHECK: "您确定要删除所有的提示吗？",
    ERROR_POST: '该贴文可能被删除，请重新整理INBOX内容。',
    NO_NOTIFICATION: '暂时没有新消息，现在可以放松一下~',
    ALL_HAVE_READ: '恭喜您，所有消息都已读取!',
  },
  FOLLOW: {
    CONTACT: "追踪或取消追踪所选联络人",
    ORG: "追踪或取消追踪所选公司",
    CASE: "追踪或取消追踪所选案件",
    OPPTY: "追踪或取消追踪所选商机",
    FOLLOW: '追踪',
  },
  UPLOADSTATUS: {
    METHOD: '方式',
    TYPE: '类型',
    CREATE_TIME: "建立时间",
    UPDATED_TIME: "更新时间",
    FILE_NAME: "文件名",
    TOTAL: "总计",
    SUCCESS: "成功",
    FAIL: "失败",
    STATUS: "状态",
    COMMENT: "纪录",
    UPLOAD: '上传',
    IMPORT: '汇入',
    PROCESSING: "处理中",
    COMPLETE: "完成",
    EMBEDDING: "分析中",
    SHOW: '显示纪录',
    NO_RECORD: '尚无纪录',
    MESSAGE_DELETE: '您确定要删除纪录吗？',
  },
  AL_MAIL: {
    TITLE: 'AI撰写助手',
    GENERATE: "AI讯息生成",
    SETTING: "AI生成设定",
    SEND_ALL: "全部送出",
    TONE: "语调",
    LENGTH: "长度",
    LANGUAGE: "语言",
    TIP: "提示",
    SIGN: "签名文件",
    REMAKE: "重新生成",
    REMAKEING: "生成中...",
    NO_AMIL: "尚无AI讯息",
    SENDING: "寄送中...",
    FOLLOWUP: "回复查询",
    SUMMARY: "提出摘要",
    CUSTOM: "自定义",
    TONE_1: "专业",
    TONE_2: "放松",
    TONE_3: "刺激",
    TONE_4: "有趣",
    TONE_5: "热情",
    LEN_1: "简短",
    LEN_2: "中等",
    LEN_3: "详细",
    STATUS_1: "尚无讯息",
    STATUS_2: "已生成",
    STATUS_3: "已储存",
    STATUS_4: "尚未储存",
    STATUS_5: "失败",
    CHANGE_ERROR: "更改推播渠道或客户分群将会删除已生成的讯息。",
    UNDO: "复原",
    REMAKE_ALL: "您确定要删除现有资料，并以目前设定生成讯息吗?",
    SEND_CHECK: "您确定要送出全部讯息吗?<br>完成后将删除现有讯息、设定。",
    MAKE_MSG: "讯息生成中，请耐心等候。<br>点击更新可确认目前进度。",
    SMS_VENDOR: "请将SMS服务商设定为'三竹简讯'。若未开启此服务，请洽询UpDay服务团队。",
    NO_CONTACT: "尚无可用联络人"
  },
  SERVICE_PRODUCT_LINE: {
    ORDER_STATUS: '订单状态',
    OWNER: '负责业务',
    REMAIN_DAYS: '距离到期日',
    END_ACCOUNT_NAME: '终端用户名称',
    CONTACT: '联络人',
    TYPE: '类型',
    PROJECT_NAME: 'Support Package/专案名称',
    SLA: 'SLA',
    SERVICE_CONTENT: '维运内容',
    SERVICE_PLAN: '维运方案',
    SERVICE_VENDOR: '维运厂商',
    START_DATE: '启用日期',
    END_DATE: '验收/结束日期',
    ORDER_NUMBER: '订单编号',
    STATUS: '状态',
    NOTE: '注记',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: '专案代码',
    RELATED_OPPTY: '相关商机',
    TECH: '技术人员',
    TECH_COST: '技术人员费用',
    INVOIVE_MONTH: '发票月份',
    INVOICE_PRICE: '发票金额',
    ESTMATED_G_P: '预估毛利额',
    POFIT: '利润 (%)',
    ORGANIZATION: '公司名称',
  },
  LICENSE_PRODUCT_LINE: {
    PRODUCT_NAME: "产品品名",
    ORDER_STATUS: '订单状态',
    OWNER: '负责业务',
    REMAIN_DAYS: '距离到期日',
    END_ACCOUNT_NAME: '终端用户名称',
    CONTACT: '联络人',
    TYPE: '类型',
    PRODUCTCODE: '项目编号',
    BILLING_F: '计费频率',
    START_DATE: '购买/启用日期',
    END_DATE: '结束日期',
    ORDER_NUMBER: '订单编号',
    STATUS: '状态',
    NOTE: '注记',
    SO: 'SO',
    SO_LINE: 'SO Line',
    PO: 'PO',
    PROJECT_CODE: '专案代码',
    RELATED_OPPTY: '相关商机',
    TECH: '技术人员',
    TECH_COST: '技术人员费用',
    INVOIVE_MONTH: '发票月份',
    INVOICE_PRICE: '发票金额',
    ESTMATED_G_P: '预估毛利额',
    POFIT: '利润 (%)',
    SUBCRIPTION_NUMBER: '订阅标识符',
    AGREEMENT_NUMBER: 'Agreement Number',
    CONTRACT_LEVEL: '合约等级',
    CONTRACT_NUMBER: '合约号码',
    PA_NUMBER: 'PA号码',
    OKS_NUMBER: 'OKS号码',
    CSI_NUMBER: 'CSI号码',
    RENEW_ID: 'OCI续订ID',
    INSTANCE_NUMBER: 'Instance号码',
    ORGANIZATION: '公司名称',
  },
  PRODUCT_LINE_ITEM_LIST: {
    1: "全部",
    2: "暂存",
    3: "审核中",
    4: "审核通过",
    5: "退件",
    6: "启用中",
    7: "启用中待补件",
    8: "已补件待审",
    9: "已经续约",
    10: "不续约",
    11: "停用",
    12: "移转",
    13: "年约年付",
    14: "年约月付",
    15: "月约月付",
    16: "一次性",
    17: "每月出帐",
    18: "无账单",
    19: "试用",
    20: "专案型",
    21: '按服务 Case 数',
    22: '按服务时数',
    23: '7*24维运服务',
    24: '全包制',
    25: '专案型',
    26: '无',
    27: '自行维运',
    28: '外包厂商',
    29: 'Azure用量%制',
    30: '纬谦OP',
    31: '纬谦技术',
    32: '外包厂商',

    33: '新购',
    34: '增购',
    35: '续约',
    36: '升级',
    37: '停用',
    38: '移转',
    39: '交换',
    40: '试用',
    41: '永久授权',
  },
  OPPTY_SELECT_FIELDS_LIST: {
    1: "建立",
    2: "追踪中",
    3: "已成交",
    4: "未成交",
    5: "后续追踪",

    6: "高科技",
    7: "制造业",
    8: "信息/软件",
    9: "政府",
    10: "教育(学校)",
    11: "其他公家单位",
    12: "医院",
    13: "医疗相关",
    14: "营建",
    15: "零售/批发",
    16: "饭店/民宿",
    17: "顾问/投资",
    18: "金融/会计",
    19: "保险",
    20: "NPO/财团法人",
    21: '服务业',
    35: '預設',

    22: 'Web Leads',
    23: '客服电话',
    24: '官网',
    25: '客服信箱',
    26: '活动',
    27: '业务商机',
    28: '其他',

    29: '0%(待联系)',
    30: '20%(洽谈)',
    31: '40%(销售)',
    32: '60%(议价)',
    33: '80%(成交)',
    34: '100%(进帐)', // 35已用在21下
  },
  // GPT----------------------------------------------------------------
  GPT_MENU: {
    DASHBOARD: "仪表板",
    KNOWLEDGE: "知识库",
    CHATBOT: "AI 机器人",
    CHATBOTS: "AI 机器人",
    CHAT_HISTORY: "交谈纪录",
    USER_MANAGEMENT: "用户管理",
    GROUP_MANAGEMENT: "团队管理",
    DATA_CENTER: "数据中心",
    USAGE_ANALYSIS: "用量分析",
    UPLOADSTATUS: '上传纪录',
    BACKTO: "回到",
    MEETINGRECAP: "会议记录",
    AINOTEBOOK: "AI 笔记本",
    PORTAL: "Portal",
    USER_ANALYSIS: "对话分析",
    LOGIN_PAGE_SETTING: "登录页设置",
    INTEGRATIONS: "对接设置",
  },
  INTEGRATION: {
    TITLE: "对接设置",
    SUBTITLE: "管理第三方系统调用 UpGPT 对接 API 所使用的 API key。",
    TAB: {
      API_KEYS: "API Key",
      CALL_LOGS: "调用记录",
      HOW_TO: "如何对接",
    },
    HOW_TO: {
      STEP1_TITLE: "创建 API key",
      STEP1_DESC: "在「API Key」分页创建 API key，并在创建时自行保存完整 key。关闭显示窗口后，系统不会再显示完整内容。",
      STEP2_TITLE: "设置 API key 可调用的 API",
      STEP2_DESC: "在 API key 列表点选「设置可调用的 API」，为此 key 勾选可调用的对接 API。未勾选任何 API 的 key 无法调用对接 API。",
      STEP3_TITLE: "调用 API 时在 header 中带入 API key",
      STEP3_DESC: "调用指定的对接 API 时，在 request header 中带入 API key：",
      STEP3_NOTE: "各对接 API 的 URL、request body 与响应格式，可在「设置可调用的 API」中点选「查看调用方式」查看。",
      GO_TO_API_KEYS: "前往 API Key 分页",
      HEADER_NAME: "X-API-Key",
      API_KEY_PLACEHOLDER: "<YOUR_API_KEY>",
    },
    KEY: {
      CREATE: "创建 API Key",
      NAME: "名称",
      NAME_HINT: "用于识别此 key 的用途，例如对接的系统名称。",
      NAME_PLACEHOLDER: "例如：官网客服机器人",
      NAME_REQUIRED: "请输入名称。",
      NAME_DUPLICATE: "此名称已被使用。",
      CREATED_TITLE: "API Key 已创建",
      CREATED_FULL_KEY: "「{name}」的完整 API key：",
      CREATED_WARNING: "关闭此窗口后将无法再次查看此 API key，请立即复制并妥善保存。",
      CREATED_LOST_HINT: "遗失时只能删除后重新创建。",
      CREATED_NEXT_STEP: "新的 API key 尚未设置可调用的 API，请接着完成「设置可调用的 API」。",
      SAVED_CLOSE: "我已保存，关闭",
      COL_KEY: "Key",
      COL_ALLOWED_APIS: "可调用的 API",
      COL_STATUS: "状态",
      COL_CREATED: "创建时间",
      COL_ACTIONS: "操作",
      ENABLED: "已启用",
      DISABLED: "已停用",
      ENABLE: "启用",
      DISABLE: "停用",
      DELETE: "删除",
      SET_ALLOWED_APIS: "设置可调用的 API",
      VIEW_CALL_LOGS: "查看调用记录",
      DELETE_TITLE: "删除 API key「{name}」？",
      DELETE_DESC: "使用此 key 的调用将全部失败，其调用记录也会一并删除，且无法恢复。",
      EMPTY: "尚未创建任何 API key。",
      EMPTY_DESC: "创建 API key 后，第三方系统即可在 request header 中带入 key 调用 UpGPT 对接 API。",
    },
    ALLOWED: {
      DESCRIPTION: "勾选此 key 可调用的对接 API，保存后立即生效。可以全部不勾选，此时此 key 无法调用任何对接 API。",
      VIEW_API_REFERENCE: "查看调用方式",
      USAGE_TITLE: "调用方式 — {name}",
    },
    API: {
      simple_agent_ask: {
        NAME: "向 Simple Agent 提问",
        DESCRIPTION: "指定一个 Simple Agent 并提出问题，一次取得完整回答与引用来源（单轮问答，不延续先前对话）。",
      },
    },
    REF: {
      BACK: "返回 API 列表",
      METHOD_AND_URL: "方法与 URL",
      METHOD: "方法",
      HEADERS: "Header",
      REQUEST_BODY: "Request Body",
      RESPONSE: "Response",
      SUCCESS_RESPONSE: "成功响应（200）",
      ERRORS: "错误响应",
      REQUEST_BODY_EXAMPLE: "Request body 示例",
      CURL_EXAMPLE: "cURL 示例",
      RESPONSE_EXAMPLE: "Response 示例",
      ERROR_EXAMPLE: "错误响应示例",
      ERROR_CODE: "错误代码",
      REASON: "原因",
      HTTP_STATUS: "HTTP Status",
      AVAILABLE_AGENTS: "可指定的 Simple Agent",
      AGENT_ID: "Agent ID",
      AGENT_NAME: "Agent 名称",
      NO_AGENTS: "此租户尚无公版 Simple Agent。",
      PLACEHOLDER_NOTE: "示例中的 API key 以占位文字表示，请替换成你保存的完整 key。",
      HEADER_DESC: "你的 API key，每次调用都必须带入。",
      ERROR_FORMAT: "所有错误响应均为 JSON，包含 code 与 message，code 一律为小写。",
      COL_FIELD: "字段",
      COL_TYPE: "类型",
      COL_REQUIRED: "必填",
      COL_DESCRIPTION: "说明",
      COL_VALUE: "值",
      YES: "是",
      NO: "否",
      FIELD: {
        agent_id: "要提问的 Simple Agent 的 ID，可从下方「可指定的 Simple Agent」获取。",
        question: "提问内容（文字），最多 1000 字；只有空白字符视为未填。",
        answer: "Agent 的完整回答。引用处以 [1]、[2] 标记，数字对应 citations 的 index。",
        citations: "回答引用的来源，按 index 排序；未引用时为空数组。",
        index: "引用序号，对应 answer 中的 [n]。",
        source: "来源类型：knowledge（知识库文档）或 web（网络搜索）。",
        title: "知识库文档为文件名；网络搜索为网页标题。",
        section: "知识库文档的章节标题；没有时为 null。",
        pages: "知识库文档引用的页码；没有页码或来源为网络搜索时为空数组。",
        url: "只有网络搜索提供网页网址；知识库文档一律为 null。",
      },
      ERROR_REASON: {
        missing_api_key: "请求未带 X-API-Key header。",
        invalid_api_key: "API key 不存在或已删除。",
        api_key_disabled: "API key 已停用。",
        api_not_allowed: "API key 未被授权调用此 API，请在「设置可调用的 API」中勾选。",
        invalid_request: "请求体缺少必填字段或格式错误，message 会指出有问题的字段。",
        agent_not_found: "指定的 Agent 不存在、已删除、非公版、已停用或未发布。",
        internal_error: "处理过程发生错误。",
        agent_timeout: "超过最长等待时间（30 分钟），Agent 未在时限内响应。",
      },
    },
    LOG: {
      COL_TIME: "调用时间",
      COL_API: "API",
      COL_HTTP_STATUS: "HTTP Status",
      COL_KEY: "API Key",
      SUCCESS: "成功",
      FAILED: "失败",
      EMPTY: "暂无调用记录。",
      EMPTY_FILTERED: "没有符合筛选条件的调用记录。",
      FILTER_RESULT: "结果",
      FILTER_FROM: "调用时间（起）",
      FILTER_TO: "调用时间（止）",
      FILTER_ALL: "全部",
      FILTER_CLEAR: "清除筛选",
      DETAIL_TITLE: "调用记录详情",
      TOTAL: "共 {count} 条",
    },
    TOAST: {
      ENABLED: "已启用「{name}」。",
      DISABLED: "已停用「{name}」，使用此 key 的调用将被拒绝。",
      DELETED: "API key 已删除。",
      ALLOWED_SAVED: "已保存可调用的 API。",
      ERROR: "操作失败，请稍后再试。",
    },
    COMMON: {
      COPY: "复制",
      COPIED: "已复制",
      CANCEL: "取消",
      SAVE: "保存",
    },
  },
  KB_AND_BOT_PERMISSION_SETTING: {
    PERMISSION_SETTING: "权限设定",
    MANAGER: "管理员",
    VIEWER: "查看者",
    ONLY_SYSTEM_ADMIN: "只有系统管理员",
    CUSTOM_SETTING: "自订",
    ALL_USER: "全部使用者",
    SEARCH_USER: "搜索使用者",
    SEARCH_GROUP: "搜索群组",
    CLEAR_SEARCH: "清除搜索",
    SELECT_ALL_RESULTS: "全选搜索结果",
    NO_MATCH_USER: "找不到符合「{q}」的使用者",
    NO_MATCH_GROUP: "找不到符合「{q}」的群组",
  },
  GPT_KNOWLEDGE: {
    TITLE: "知识库总览",
    UPLOADER: "上传者",
    UPLOAD_TIME: "上传时间",
    FILE_STATUS: "状态",
    STATUS_COMPLETE: "上传完成",
    STATUS_PROCESSING: "处理中",
    PROCESS_METHOD: "处理方式",
    NAME: "知识库名称",
    DOCS: "文件总数",
    CREATED_ON: "建立时间",
    UPDATED_ON: "更新时间",
    UPDATED_BY: "更新者",
    ROBOTS: "机器人",
    BACKTO: "回到",
    LAST_UPDATED: "最后更新",
    OPEN_LIB: "开启",
    CLOSE_LIB: "关闭",
    ONOFF: "开启/关闭 知识库",
    LINKBOT: "连结 AI 机器人",
    NO_LINKBOT: "尚未连结",
    CLEAR: "清空",
    CLEAR_ALL: "清空知识库",
    DELETE_SIMPLE: '刪除',
    DELETE: '删除知识库',
    DEL_MSG: "您确定要删除此知识库吗?",
    CLEAR_MSG: "您确定要清空此知识库吗?",
    SETTING: "知识库设定",
    UPLOAD: "知识库档案上传",
    ERROR: "此知识库名称已存在",
    PUBLIC: "全域知识库",
    ISPUBLIC: "已共享",
    ADD_COLUMN: "新增字段",
    EDIT_COLUMN: "修改字段",
    ADD: "新增",
    EDIT: "修改",
    CLEAR_ERROR: "知识库档案清空中，请稍后重新整理画面。",
    DELETE_ERROR: "知识库档案清空后将进行删除，请稍后重新整理画面。",
    SYSTEM_NAME_ERROR: "已有相同System Name于其他知识库，请重新输入。",
    SINGAL_DELETE: "您确定要删除此档案吗?",
    MULTIPLE_DELETE: "删除选取档案",
    MULTIPLE_DELETE_CHECK: "您确定要删除选取的 {count} 个档案吗?",
    MULTIPLE_DELETE_PROGRESS: "已删除 {done} / 共 {total} 笔",
    MULTIPLE_DELETE_RESULT: "删除完成：成功 {success} 笔，失败 {fail} 笔。失败的档案可能仍在处理中，请稍后重新整理确认。",
    DELETEING: "档案删除中，请稍后重新整理此页面。",
    IMAGE_SELECTION: "图片处理选项",
    TIP_1: "将用以下档案建立知识库，AI机器人会以此知识库内容回答问题。",
    TIP_2: "在此上传Q&A档案，档案需为csv格式且内容使用UTF-8编码。",
    TIP_3: "在此上传压缩文件，档案需为zip格式，请直接将文件压缩，不需另外放入文件夹。",
    TIP_4: "在此上传txt、pdf、docx、pptx档案，如需上传csv文件，请至Q&A资料上传。",
    TIP_4_IDP: "在此上传pdf、docx、pptx、xlsx档案，如需上传csv文件，请至Q&A资料上传。",
    TIP_5: "在此新增需要分析的网站，最多可新增5个网站，深度最多为2，新增完成后请按'开始分析'。",
    TIP_6: "在此上传JPG、JPEG、PNG 格式图片。",
    TIP_7: ", 記錄保留21天",
    TIP_8: "在此上传pdf、docx、pptx、jpg、jpeg、png 格式。",
    SYSTEM_NAME_TIP: "必须是英文，不可重复，协助AI搜寻知识库 e.g. HR, Product, Safety, etc",
    SYSTEM_NAME_LABEL: "System Name",
    DESCRIPTION_TIP: "描述有助于人工智慧理解这些知识对于搜寻的意义",
    CATEGORY: "类别",
    PROCESSING_FILE: "處理中的文件",
    KNOWLEDGE_FOLDER: "知识库资料夹",
    KNOWLEDGE: "知识库",
    UPDATE_FOLDER_PERMISSION: "是否要将此权限套用至所有子文件夹与知识库? 此操作将覆盖子文件夹与知识库的权限",
    MOVE_SAME_LOCATION: "目前选择的位置与原本相同，知识库位置不会变更，请重新选择",
    MOVE_NO_PERMISSION: "您没有此知识库或目标文件夹的管理权限，无法变更位置。",
    MOVE_FAIL: "变更位置失败，请稍后再试。",
  },
  ADD_KNOWLEDGE: {
    TITLE: '新增知识库',
    KB: '知识库',
    FOLDER: '资料夹',
    CATEGORY: "类别",
    CATEGORY_PH: "选择或新增类别",
    CATEGORY_HTNT: "填入知识库类别,例如: 人资,产品,资讯部等。",
    NAME: '名称',
    NAME_PH: "知识库名称",
    NAME_HINT: '名称不能重复，且知识库建立后，名称将不能修改。',
    SYSTEM_NAME_HINT: "必须是英文，也不可重复，用于系统识别。",
    DESCRIPTION: '描述',
    DESCRIPTION_PH: "字数限制在100字元以内。",
    DESCRIPTION_HINT: "该描述为必填，有助于 AI 理解并搜寻相关资讯。",
  },
  KNOWLEDGE_FOLDER: {
    library: '知识库',
    folder: '资料夹',
  },
  ADD_KNOWLEDGE_FOLDER: {
    TITLE: '新增资料夹',
    EDIT_TITLE: '編輯资料夹',
    NAME: '名称',
    PATH: '父层',
    PERMISSION_SETTING: '权限设定',
    ONLY_SYSTEM_ADMIN: '只有系统管理员',
    ONLY_SYSTEM_VIEWER: '全部使用者',
    CUSTOM_SETTING: '自订',
    PERMISSION_SETTING_DEFAULT: '(预设为父层的权限设定)',
    DELETE_MSG: '此操作将删除所有子资料夹与知识库，确定要删除吗?',
    ERROR1: '目前选择的路径与原本相同，资料夹位置不会变更，请重新选择',
    ERROR_2: '不可将父文件夹设置为自己的子文件夹。',
    ERROR_3: '文件夹名称已存在，请重新输入。'
  },
  FOLDER_LOCATION_PICKER: {
    TITLE: "选择文件夹",
    CURRENT: "当前选择",
    NOT_SELECTED: "尚未选择",
    CREATE_FOLDER: "新建文件夹",
    PLACEHOLDER: "选择文件夹…",
    DRAFT_HINT: "新建",
    NEW_FOLDER_DEFAULT: "新建文件夹",
  },
  GPT_UPLOADIMG: {
    DESCRIBE_IMG: '图像理解',
    CUSTOMER_ATTRIBUTE: '客制属性',
    IMG_SEARCH: '以图搜图',
    IDP: '智慧文档处理',
    TIP_1: "AI会对图像进行详细描述，用户可以根据它提出问题并搜索答案。",
    TIP_2: "AI 将从图像中提取属性并保存到表格中。如果您希望 AI 回答像「亚洲最昂贵的前三项物品」这样的问题，这将非常有用。请联系我们以启用此功能。",
    TIP_3: "AI会分析用户传送的影像，并为用户找到相似的影像。对于产品搜寻等场景很有用。",
    FILEUPLOADMESSAGE: '仅接受 JPG、JPEG、PNG 檔',
    START_ANALYSIS: '开始分析',
    IMAGE_STATUS: '状态',
    IMAGE_TIP_1: "图片处理功能仅在企业版中可用。请联系 support@upday.ai 以启用此功能。",
    IMAGE_TIP_2: "智慧文档处理仅在企业版中可用。请联系 support@upday.ai 以启用此功能。",
    IMAGE_TIP_3: "图片处理功能和智能文文件处理在企业版中可用。请联系 support@upday.ai 以启用此功能。",
    CLOUD_TIP: "云端档案处理功能仅在企业版中可用。请联系 support@upday.ai 以启用此功能。",
  },
  GPT_CLOUD: {
    CONNECT_CLOUD: '连结云端',
    CONNECT_ACCOUNT: '连结账号',
    RESET: '重置',
    SAVE: '储存',
    DELETE_CHECK: '您确定要删除此云端账号设定吗?\n确认后，所有已链接的档案将从知识库中删除。',
    CLOUDSYNC_ERROR: '删除失败，请重试',
    MY_DRIVE: '我的档案',
    SHARE_WITH_ME: '已共享',
    SHAREPOINT: 'Sharepoint',
    ONEDRIVE_LOCKED: '此账号的 OneDrive 目前无法访问（已被锁定），请联系贵组织的 Microsoft 365 系统管理员协助解除',
    ONEDRIVE_ACCESS_FAILED: 'OneDrive 访问失败，请稍后再试或联系管理员',
    EXCEED_MAX_SIZE: '上传档案总量大小超过',
    MAX_FILES: "档案数量过多，仅显示前2000笔数据。",
  },
  GPT_ANALYSIS: {
    NAME: "数据分析",
    USED_TOKEN: "消耗 Token",
    MSG_TOKEN: "平均每讯息消耗 Token",
    MSG_Q: "讯息量",
    MSG_PER_Q: "平均花费 Token",
    ACU: "累积消耗 Token",
    THIS_PERIOD: '本期',
    PREVIOUS: '上期',
    TABLE_HEADER_1: "智能机器人",
    TABLE_HEADER_2: "频道",
    TABLE_HEADER_3: "Prompt Tokens",
    TABLE_HEADER_4: "Completion Tokens",
    TABLE_HEADER_5: "费用",
    TABLE_HEADER_6: "时间",
    TABLE_HEADER_7: "知识库",
    TABLE_HEADER_8: "使用类型",
    TABLE_HEADER_9: "租户",
    TABLE_HEADER_10: "订阅到期日",
    STORAGE_USAGE: '存储器使用量',
    IMAGE_STORAGE_USAGE: '图片存储器使用量',
    STORAGE_USAGE_TIP: "所有知识库中已链接的档案大小",
    IMAGE_STORAGE_USAGE_TIP: "所有知识库中已链接的图片数量",
    INTELLIGENT_DOCUMENT_USAGE_TIP: "所有智能文档处理分析使用数量",
    USED: '已使用',
    PIECE: "张",
    PAGE: "页",
    END_DATE: ' 到期日:',
    REMAIN_AMOUNT: '剩余金额',
    USING_AMOUNT: '使用金额'
  },
  GPT_TREADANALYSIS_DRAWER: {
    THREAD: "话题",
    FEEDBACK: "有帮助",
    HELPFUL: "有帮助",
    UNHELPFUL: "没帮助",
    ACCURACY: "准确度",
    RELEVANCE: "关联度",
    REFERENCES: "参考",
    ANSWER: "回复",
  },
  GPT_USER_ANALYSIS: {
    ANSWER: '回复',
    HELPFUL: '有帮助',
    UNHELPFUL: '没帮助',
    RELEVANCY: '关联度',
    RELEVANCY_H: '关联度高',
    RELEVANCY_L: '关联度低',
    STATISTICS: "统计",
    RELATED: "相关",
    UNRELATED: "不相关",
    ACCURACY: "准确度",
    ACCURACY_H: "准确度高",
    ACCURACY_L: "准确度低",
    DATE: "日期",
    CATEGORY: "类别",
    AVG_RELEVANCY: "平均关联度",
    AVG_ACCURACY: "平均准确度",
    TOTAL_ANSWER: "回复总数",
    HELP_UNHELP: "有帮助/没帮助",
    THIS_WEEK: "本周",
    RECORDS: "笔",
    ALL: "全部",
    TODAY: "今天",
    THIS_MONTH: "本月",
    DATE_RANGE: "选择日期",
    LAST_7_DAYS: "最近7天",
    SELECT_DATE_RANGE_ERROR: "请输入选择日期"
  },
  GPT_THREAD_ANALYSIS: {
    THREAD_ANALYSIS: "话题总览",
    DATE: "日期",
    THREAD_NAME: "话题",
    ANSWER: '回复',
    HELPFUL: '回馈',
    ACCURACY: "准确度",
    RELEVANCY: "关联度",
    FILES: "参考",
    NO_FEEDBACK: "未回应"
  },
  GPT_IDP: {
    DOCUMENT_ANALYSIS: '智慧文档处理',
    REMAIN_DOCUMENT_ANALYSIS: '剩余智慧文档数量',
    DOCUMENT_ANALYSIS_STORAGE_USAGE: '智能文档处理使用量',
    TIP_1: '使用智能文档处理来分析您的文件。请在用量分析页面检查您的可用配额',
  },
  GPT_AIBOTS: {
    TITLE: "AI 机器人总览",
    AIASSISTANTNAME: 'AI 机器人名称',
    AIASSISTANTNAME_TIP1: '设定您 AI 机器人的名称',
    AIASSISTANTNAME_TIP2: '范例: 小安',
    AIASSISTANTROLE: 'AI 机器人角色',
    AIASSISTANTROLE_TIP1: '设定您 AI 机器人所扮演的角色',
    AIASSISTANTROLE_TIP2: '范例: customer service agent (客服人员) for UpDay, a CRM production designed by 安然科技股份有限公司',
    TOPIC: '主题',
    TOPIC_TIP1: '提供 AI 机器人一个主题，使其能更好的改写提问',
    TOPIC_TIP2: '范例: UpDay CRM',
    TOPICLIMIT: '主题限制',
    TOPICLIMIT_TIP1: '如果问题超出主题, AI 机器人会回到应有的主题范围回复',
    TOPICLIMIT_TIP2: '范例: technology',
    REPLY_LANGUAGE: '回复语言',
    REPLY_LANGUAGE_TIP: 'AI 机器人会依据所选择的语言回复',
    MODEL: 'AI模型',
    MEMORY_LENGTH: '机器人记忆长度',
    RETURN_KNOWLEDGE: '使用知识数量',
    INBOX: "收件匣",
    HAS_LINKED_BOT: "此收件匣已连结其他机器人。",
    NO_EXIST_BOT: "尚无UpChat机器人，请联系UpGPT客服进行设置。",
    VERBOSITY: "回应详尽程度",
    REASONING_EFFORT: "推理投入程度"
  },
  ADD_AIBOTS: {
    TITLE: '新增 AI 机器人',
    NAME: '名称',
    DESCRIPTION: '描述',
    INBOX: "收件匣",
    KNOWLEDGE: "知识库",
    CONNECT_TO: "连接至",
    MEMORY_LENGTH: '记忆长度',
    RETURN_KNOWLEDGE: '使用知识量',
    RETURN_TONE: '回复语气',
    RETURN_LEN: '回复长度',
    AI_DISCLAIMER: '允许AI免责声明',
    CITATION: '允许显示引用来源',
    FILELINK: '回传档案连结',
    IMAGE_SEARCH: '允许图片搜寻',
    RETURN_IMAGE_QUANTITY: '回传图片数量',
    RETURN_REPLY_WITH_IMAGE: '允许回复回传图片',
    SHOW_ALL_IMAGE: "显示所有文档图片",
    HIDE_ANSWER_WITHOUT_REFERENCE: "若无参考资料则隐藏回答",
    SHOW_PRIVATE_KNOWLEDGE: "显示私人知识库",
    WEB_SEARCH_TOGGLE: "允许网页搜索",
    ROLE: "角色",
    SCOPE: "回复限制",
    TOPIC: "主题",
    ONOFF: "开启/关闭 AI 机器人",
    DETAIL: "AI 机器人详细资料",
    BRAIN_SIZE: "知识储备",
    C_SETTING: "角色设定",
    DEL_MSG: "您确定要删除此 AI 机器人吗?",
    BEST_SIZE: "最佳尺寸: 120*30px",
    M_1: "微调知识设定。",
    M_2: "AI 机器人将根据提供的知识库进行响应。",
    M_3: "设定愈多的内存长度会参考愈多的上下文，但响应速度会减慢。\n设定愈多的使用知识量，将提供更精确的响应，但速度会减慢。",
    M_4: "AI 机器人会根据使用者的角色设定做出反应和响应。",
    M_5: "角色会影响响应的语气和态度。",
    M_6: "如果问题超出主题，AI 机器人会回到应有的主题范围回复。",
    M_7: "提供 AI 机器人一个主题，使其能更好的改写提问。",
    M_8: "AI 机器人的自称。",
  },
  DETAIL_LEVEL: {
    "CONCISE": "精简",
    "NORMAL": "一般",
    "DETAILED": "详细",
  },
  TONE_LEVEL: {
    "PROFESSIONAL": "专业",
    "FRIENDLY": "友善",
    "CASUAL": "轻松",
    "INSPIRING": "启发",
    "PASSIONATE": "热情",
    "WARM": "温暖",
  },
  GPT_UPLOAD: {
    DEL_K: "已删除的知识库",
    AutoSync: "云端自动同步",
    ManualSync: "云端手动同步",
    AutoKnow: "链接的知识库"
  },
  GPT_USER: {
    T_1: "个人信息",
    T_2: "变更密码",
  },
  GPT_CHAT_HISTORY: {
    CHANNEL: "渠道",
    C_USER_NAME: "使用者名称",
    LAST_CHAT_TIME: "最后对话时间",
    L_SELECT: "请从左侧选择一个对话",
    SEARCH: "搜寻讯息",
  },
  GPT_MEETINGRECAPS: {
    TITLE: "会议记录总览",
    NAME: "名称",
    participants: "参与者",
    OWNER: "拥有者",
    TIME: "时间",
    DELETE: "您确定要删除此会议纪录吗？"
  },
  GPT_MEETINGRECAP: {
    TITLE: "会议记录",
    NAME: "会议名称",
    MS: "会议总结",
    OWNER: "拥有者",
    MS_TIME: "会议时间",
    ANR: "关联AI记事本",
    AN: "AI 记事本",
    OPPTY: "商机",
    ANs: "AI 笔记",
    TS: "文字纪录",
    ANALYZE: "AI分析",
    SUGGEST_TASKS: "建议任务",
    CREATE_TASKS: "创建任务",
    VIEW_TASKS: "检视任务",
    SUMMARY: "生成总结",
    VALIDATE: "请确认必填字段，并绑定商机。",
    NO_T: "没有文字纪录。",
    DELETED_MEETING_RECAP: "此会议记录已被删除，请重新整理页面",
    EXIST_SUMMARY_AND_TASK: "会议总结及任务已被生成，请重新整理页面并确认内容",
    MAIL_SETTING: "信件设定确认中",
    MAIL_GENERATE: "AI 信件生成中",
    EMPTY_SUMMARY: "AI 无法从空白的会议总结中生成合适的email",
    EMPTY_CUSTOM_PROMPT: "AI 无法以空白的prompt生成合适的email",
    EMPTY_SUMMARY_TASK: "AI 无法从空白的会议总结中生成合适的任务",
    TASK_CANT_FIND_ACTIVITY: "相关的活动已被删除，请再次创建新的任务",
  },
  GPT_AINOTEBOOK: {
    TITLE: "AI 笔记本总览",
    LAST_UPDATED: "最后更新",
    DESCRIPTION: '描述',
    RECORD_TYPE: '纪录类型',
    DELETE: "您确定要删除此AI 笔记本吗？",
    DELETE_ERROR: "至少需有一个AI 笔记本",
    DEFAULT: "系统默认",
    CRM_TIP: "选择您希望小安在会议中自动为您撷取的 CRM 数据。",
    AI_NOTE_TIP: "自定义您希望小安在会议中自动为您撷取的数据。",
  },
  ADD_AINOTEBOOK: {
    TITLE: '新增AI 笔记本',
    EDIT: '编辑AI 笔记本',
    ADD: '新增字段',
    COLUMN: '字段',
    NAME: '名称',
    DESCRIPTION: '描述',
    DELETE_ERROR: "您确定要删除此字段吗？",
    NAME_HINT: 'AI 笔记本建立后，名称将不能修改。',
    COLUMN_NAME_HINT: '字段建立后，名称将不能修改。',
    LIMIT_HINT: '字段描述限制50字。',
    LIMIT_COLUMNS: '字段数量已达上限。',
    CRM_SYSTEM_FIELD: 'CRM字段',
  },
  //Up Meeting
  UPMEETING: {
    LOGIN: "UpSide AI 助理",
    ANN: "小安",
    CHANGE_AN: "更换AI记事本将会清除已纪录的信息。",
    NOTE_C: "个字段已完成填写。",
    MEETING_OVER: "您的会议已结束，点击以下链接查看纪录：",
    L_D_TITLE: "是否保留上次参加的会议?",
    L_D_LAST: "继续之前的会议",
    L_D_NEW: "开始新的会议",
    FINISH: "结束",
    CAPTION_ERROR: "请先开启Teams或Google会议。",
    IMAGE_PREFIX: "AI问题分析中...",
    QUERY_PREFIX: "AI关键词生成中...",
    SEARCH_PREFIX: "AI信息分析中...",
    IMAGE_ERROR: "图片分析失败，请在试一次。",
    BACKEND_ERROR: "您没有权限，或是系统设定有误，请联系系统管理员。",
    SHOT_BTN_TITLE: "AI信息分析",
    NO_QA: "请点击AI图标或输入关键词进行搜寻。",
    Problem_Analysis: "问题分析",
    Causes_Analysis: "原因分析",
    Solutions: "解决方案",
    Actions: "行动",
    References: "参考数据",
    OutlookError: "没有开启的邮件，或是设定不符",
    VisionOn: '影像开启',
    VisionOff: '影像关闭',
    WAITING: "正在读取与分析资料中，请稍等片刻",
  },
  // Order
  ORDER: {
    TITLE: '订单',
    WIADVANCE_TITLE: '合约',
    NAME: '订单名称',
    WIADVANCE_NAME: '合约名称',
    ENDACCOUNT: '终端用户名称',
    CLIENT_NAME: '客户名称',
    ORGANIZATION_NAME: '公司名称',
    ENDACCOUNT_NAME: '终端客户名称',
    CONTACT_NAME: '联络人',
    SHIPPING_METHOD: '运送方式',
    PAYMENT_TERM: '付款条件',
    SHIPPING_TERM: '运费条件',
    BILLING_ADDRESS: '发票地址',
    SHIPPING_ADDRESS: '收件地址',
    DESCRIPTION: '描述',
    AMOUNT: '金额',
    ORDER_STATUS: '订单状态',
    WIADVANCE_ORDER_STATUS: '合约状态',
    ORDER_SALES: '负责业务',
    FROM_DATE: '距离到期日',
    TYPE: 'Type',
    BILLING_FREQUENCY: '计费频率',
    PRODUCT_CODE: '项目编号',
    PROJECT_CODE: 'Project Code',
    PRODUCT_NAME: '产品品名',
    QUANTITY: '套数',
    START_DATE: '启用日期',
    PURCHASE_ACTIVATION_DATE: '购买/启用日期',
    ACCEPTANCE_COMPLETION_DATE: '验收/结束日期',
    DUE_DATE: '结束日期',
    ORDER_NUMBER: '订单编号',
    STATUS: '状态',
    NOTE: '注记',
    PROJECT_NAME: 'Support Package / 专案名称',
    SERVICE_CONTENT: '维运内容',
    SERVICE_PLAN: '维运方案',
    MESSAGE_DEL_ORDER: '您确定要删除此笔数据？',
    SERVERS: '服务器',
  },
  ORDER_DETAIL: {
    ORDER_TYPE: '订单类型',
    WIADVANCE_ORDER_TYPE: '合约类型',
    OWNER: '订单拥有者',
    WIADVANCE_ORDER_OWNER: '合约拥有者',
    NO_REGARDING: '请输入公司名称进行搜寻',
    TIMELINE: '时间轴',
    NO_TIMELINE: '尚无时间轴',
    //----TAB      
    DETAIL: '详细资料',
    PRODUCT: '产品',
  },
  ADD_ORDER: {
    TITLE: '新增订单',
    WIADVANCE_TITLE: '新增合约',
    NAME: '订单标题',
    WIADVANCE_NAME: '合约标题',
    ORZ: '选择客户',
    CONTACT: '选择联络人',
    NO_CONTACT: '请输入联络人姓名进行搜寻',
    NEW_CONTACT: '建立全新联络人',
    OLD_CONTACT: '选择已有联络人',
    AMOUNT: '金额',
    SHIPPING_METHOD: '运送方式',
    PAYMENT_TERM: '付款条件',
    SHIPPING_TERM: '运费条件',
    BILLING_ADDRESS: '发票地址',
    SHIPPING_ADDRESS: '收件地址',
    FIRST_NAME: '使用者名称',
    LAST_NAME: '使用者姓氏',
  },
  SHIPPINH_METHODS: {
    AIR_FREIGHT: '空运',
    MAIL_DELIVERY: '邮递邮件',
    FULL_LOAD: '完整加载',
    PICK_UP: '提货'
  },
  SHIPPINH_TERM: {
    FREE_SHIPPING: '免运费',
  },
  PAYMENT_TERM: {
    PAYMENT_WITHIN_30D: '30天内付款',
    PAYMENT_WITHIN_30D2PERCENT: "2% 10，30天内付款",
    PAYMENT_WITHIN_45D: "45天内付款",
    PAYMENT_WITHIN_60D: "60天内付款",
    PAYMENT_WITHIN_90D: "90天内付款",
  },
  THEDAYOFEVERYMONTH: {
    1: '每月1日',
    2: '每月2日',
    3: '每月3日',
    4: '每月4日',
    5: '每月5日',
    6: '每月6日',
    7: '每月7日',
    8: '每月8日',
    9: '每月9日',
    10: '每月10日',
    11: '每月11日',
    12: '每月12日',
    13: '每月13日',
    14: '每月14日',
    15: '每月15日',
    16: '每月16日',
    17: '每月17日',
    18: '每月18日',
    19: '每月19日',
    20: '每月20日',
    21: '每月21日',
    22: '每月22日',
    23: '每月23日',
    24: '每月24日',
    25: '每月25日',
    26: '每月26日',
    27: '每月27日',
    28: '每月28日',
    29: '每月29日',
    30: '每月30日',
    31: '每月31日',
  },
  ORDER_TYPE: {
    LICENSE_PRODUCT: '产品型合约',
    SERVICE_PRODUCT: '服务型合约',
    LICENSE_CONTRACT: '产品型合约',
    SERVICE_CONTRACT: '服务型合约',
  },
  AGENT: {
    ICON: '选择 Icon',
    TITLE: 'AI 代理',
    GOAL: '描述(选填)',
    GOAL_Mandatory: '目的',
    IMAGE_INPUT: '图片',
    QUESTION: '问题',
    INSTRUCTION: '指示',
    KNOWLEDGE_LIBS: '知识库',
    UN_UPDATED: '尚无更新',
    CUSTOMER: '客户',
    SOLUTION: '解决方案',
    PRODUCTS: '产品',
    FILE: '文件上传',
    TRANSLATE_TO: '翻译成',
    ADD_FIELD: '新增欄位',
    FIELD_TYPE: '字段类型',
    FIELD_NAME: '字段名称',
    SYSTEM_NAME: '系统名称',
    DEFAULT_VALUE: '字段默认值',
    IS_MANDATORY: '设为必填欄位',
    CHOOSE_FILE_HINT: '请选择文件',
    LABEL_PREVIOUS_STEP: '读取上一步骤文档',
    LABEL_UPGPT_KNOWLEDGE: '读取 UpGPT 知识中的特定文档',
    AGENT_NAME_Construction_Compliance_Agent: '施工合规代理',
    AGENT_NAME_Proposal_Writing_Agent: '提案撰写代理',
    AGENT_NAME_Employee_Onboarding_Agent: '员工入职助手',
    AGENT_NAME_Document_Translation_Agent: '文件翻译助手',
    AGENT_DESCRIPTION_Construction_Compliance_Agent: '根据使用者提供的照片与问题，查找施工现场的安全资讯、施工指引、检查清单、步骤及合规相关资料。',
    AGENT_DESCRIPTION_Proposal_Writing_Agent: '根据所提供的指示、示例及信息生成提案。',
    AGENT_DESCRIPTION_Employee_Onboarding_Agent: '协助员工解答入职相关问题、查找相关信息，并提升员工的整体体验。',
    AGENT_DESCRIPTION_Document_Translation_Agent: '协助员工翻译文件内容为指定语言。',
    SEARCH_IMAGE_BY_IMAGE_NUM_IMAGE_RETURN: '图片搜索数量',
    SEARCH_KNOWLEDGE_NUM_OF_SUBQUERIES: '相关问题数量',
    IGNORE_LANGUAGE_SETTING: '忽略語言',
    INCLUDE_IN_CITATION: '分段引用',
    OUTPUT_FORMAT: '输出格式',
    STEP_user_input: '使用者输入',
    STEP_search_image_by_image: '以图搜图',
    STEP_read_document: '读取文件',
    STEP_think: '思考',
    STEP_search_knowledge: '搜索知识',
    STEP_respond: '回答',
    TEXT_MESSAGE: "输入文字",
    KNOWLEDGE_MESSAGE: "  绑定要使用的知识库",
    STEP: "步骤",
    READ_DOCUMENT_DESCRIPTION: "阅读文件内容...",
    THINK_DESCRIPTION: "进行思考与分析...",
    SEARCH_IMAGE_BY_IMAGE_DESCRIPTION: "根据图片内容搜索相关图片...",
    SEARCH_KNOWLEDGE_DESCRIPTION: "搜索知识库或文件...",
    RESPOND_DESCRIPTION: "根据上述步骤生成回复",
    FOLLOW_UP_QUESTION: "延伸问题",
    CONTENT: "相关内容",
    ADD_AGENT: "新增代理",
    ADD_SIMPLE_AGENT: "新增代理",
    EDIT_SIMPLE_AGENT: "编辑代理",
    AGENT_NAME_MSG: "输入代理名称",
    SEARCH_WEB: "搜寻网页",
    BIND_LIB: '选择知识库',
    BIND_FOLDER: '选择文件夹',

  },
  AGENT_FILE_ATTACHMENT: {
    ATTACHMENT: "附加档案",
    UPLOAD: "点击选择或将档案拖曳到此处",
    ACCEPT_TYPE: "接受档案类型 {file_type}",
    UPLOADING: "档案上传中",
    EXCEED_MAX: "系统仅支援最多 3 个档案，请重新选择符合限制的档案数量。",
    STILL_RUN: '档案上传中，请稍后重新整理页面',
    WRONGTYPEINFILE: '档案上传仅接受 pdf、docx、pptx、jpg、jpeg、png档',
    DRAG_HINT: '拖曳档案至此（最多 3 个，支援 .pdf、.docx、.pptx、.jpg、.png）',
    EXCEED_MAX_TOAST: '最多上传 3 个档案',
    EXCEED_SIZE_TOAST: '档案总大小不可超过 20MB',
  },
  AGENT_STEP: {
    STEP: '步骤',
    ANSWER: '答案',
  },
  // Document Agent
  DOCUMENT_AGENT: {
    TITLE: "AI 工作中心",
    TEMPLATE_TITLE: "选择模板",
    LINK_ACCOUNT: "连结帐号",
    ACCESS_FOLDER: "读取资料",
    GENERATE_CONSET_FORM: "生成同意书",
    SYNC_UPDATE: "同步更新",
    NO_DATA: "尚无资料可显示",
    PROPERTIES: "栏位设定",
    REGENERATE: "重新生成",
    SHOWALL: "显示所有资料",
    DELETE_CHECK: '您确定要删除此云端帐号设定吗?\n确认后，所有已连结的档案将删除。',
    DELETE_FILE_CHECK: '您确定要删除此资料连结设定吗?\n确认后，连结的档案将删除。',
    NO_REFERENCE_USED: "未引用任何参考文件",
    AI_DISCLAIMER: "AI 可能会出错，请查证。",
    RUN_AGENT: "Run Agent",
    RUN_ALL: "Run All",
    TOTAL: "总数",
    UNSUPPORTED_FILE_FORMAT: '文件格式不支持',
    FILE_FORMAT_TOOLTIP: '支持 pdf, docx, pptx, xlsx, png, jpg, jpeg, gif, webp 等文件格式',
    UNSUPPORTED_FILES_SUMMARY: '已成功上传 {successCount} 个文件，{failCount} 个文件格式不支持。\n上传失败。',
    IMAGE_PAGE_INFO: "第 {page_num} 页，第 {image_num} 张图",
    DOWNLOAD_FAILED: '文件下载失败，请稍后再试。',
    BLANK_TEMPLATE: '空白模板',
    CREATOR: '创建者',
    CREATOR_ADMIN: '管理员',
    AI_GENERATE_TITLE: '您希望 Work Agent 帮您执行哪些操作？',
    AI_GENERATE_PLACEHOLDER: '输入指令帮您生成模板，或直接建立新模板',
    AI_GENERATE_BTN: 'AI 生成',
    RETRY_BTN: '重试',
    DIRECT_CREATE_BTN: '直接建立',
    SAVE_AS_TEMPLATE: '另存新模板',
    SAVE_AS_TEMPLATE_HEADER: '另存新模板',
    SAVE_AS_TEMPLATE_NAME: '名称',
    SAVE_AS_TEMPLATE_DESC: '说明',
    SAVE_AS_TEMPLATE_STATUS: '状态',
    SAVE_AS_TEMPLATE_PRIVATE: '私人',
    SAVE_AS_TEMPLATE_PUBLIC: '公开',
    SAVE_AS_TEMPLATE_DUPLICATE_MSG: '已存在相同名称的模板，是否继续保存？',
    SAVE_AS_TEMPLATE_SAVE_BTN: '保存',
    SAVE_AS_TEMPLATE_NAME_REQUIRED: '模板名称为必填项',
    DELETE_TEMPLATE_CONFIRM: '此操作将永久删除 {name} 模板，确定要删除吗？\n已创建的 Work Agent 仍可正常使用。',
    DELETE_TEMPLATE_FAILED: '删除模板失败，请稍后再试。',
    AI_GENERATE_ERROR_TIMEOUT: 'AI 生成超时，请稍后重试或选择「直接建立」。',
    AI_GENERATE_ERROR_SERVICE: 'AI 服务发生异常，请稍后重试或选择「直接建立」。',
    AI_GENERATE_ERROR_FORMAT: 'AI 回传格式不符，请尝试修改提示词或选择「直接建立」。',
    AI_GENERATE_ERROR_CREATE: '建立 Work Agent 失败，请稍后重试或选择「直接建立」。',
    OPEN_FILE: '打开文件',
    FILE_TYPE_NOT_SUPPORTED: '此文件类型不支持预览',
    FILE_LOAD_ERROR: '文件加载失败，请稍后再试',
    NO_EXTRACTED_TEXT: '此文件暂无可显示的文字内容',
    NO_FILE_IN_COLUMN: '此栏位目前无文件',
    NO_PREVIEWABLE_FILE: '此记录无可预览的文件',
    PREVIEW_LOAD_ERROR: '无法加载预览，请尝试刷新或直接打开文件',
    PREVIEW_FETCH_ERROR: '获取预览链接失败，请稍后再试',
    EXTRACT_TEXT_ERROR: '提取文件文字失败，请稍后再试',
    RECORD_DELETED: '此记录已删除',
    RECORD_COUNT: '{current} / {total}',
    RECORD_REVIEW: '纪录审查',
    COLLECTION_LOAD_ERROR: '子集合数据加载失败',
    DATA_LOAD_ERROR: '字段数据加载失败，请稍后再试',
    EXPAND: '展开',
    COLLAPSE: '收起',
    VIEW_ORIGINAL_FILE: '原始文件',
    VIEW_EXTRACTED_TEXT: '提取文字',
    PDF_PREVIEW_LOAD_ERROR: '无法加载预览，请尝试重新切换或直接打开文件',
    PDF_PREVIEW_FETCH_ERROR: '获取预览链接失败，请稍后再试',
    REF_MODE_TEXT: "文字模式",
    REF_MODE_PDF: "PDF模式",
    REF_MODE_WEB: "参考网页",
    WEB_SEARCH_EMPTY: "此次搜索未找到任何网络来源。",
    CELL_ERROR_DEFAULT: '此栏位执行时发生错误。',
    CELL_ERROR_TIMEOUT: '执行超时',
    CELL_ERROR_FAILURE: '执行失败',
    SORT_ASC: '升序',
    SORT_DESC: '降序',
    SORT_CLEAR: '清除排序',
    SORT_TOOLTIP: '点击以排序，再次点击切换方向或清除',
    FILTER_CONTAINS: '包含',
    FILTER_NOT_CONTAINS: '不包含',
    FILTER_EQUALS: '等于',
    FILTER_NOT_EQUALS: '不等于',
    FILTER_GT: '大于',
    FILTER_GTE: '大于等于',
    FILTER_LT: '小于',
    FILTER_LTE: '小于等于',
    FILTER_BETWEEN: '介于',
    FILTER_IS_EMPTY: '为空',
    FILTER_IS_NOT_EMPTY: '不为空',
    FILTER_APPLY: '套用',
    FILTER_CLEAR: '清除',
    FILTER_CLEAR_ALL: '清除所有筛选',
    MENU_SORT: '排序',
    MENU_FILTER: '筛选',
    NO_FILTER_RESULT: '没有符合筛选条件的数据',
  },
  WORK_AGENT: {
    PERMISSION_SETTINGS: '权限设置',
    MANAGE_ACCESS: '管理访问权限',
    SHARE_BTN: '分享',
    ENTITY_TYPE_TEMPLATE: 'Work Agent 模板',
    ENTITY_TYPE_INSTANCE: 'Work Agent 实例',
    OWNER_LABEL: '拥有者',
    VISIBILITY_LABEL: '可见性',
    VISIBILITY_PRIVATE: '私有 (Private)',
    VISIBILITY_PUBLIC: '公开 (Public)',
    PRIVATE_DESCRIPTION: '仅拥有者与管理者可见',
    PUBLIC_DESCRIPTION: '全租户用户',
    MANAGER_ONLY_BANNER: '仅管理者 (is_staff) 可设置模板的可见性与分享。',
    INSTANCE_OWNER_ONLY_INFO: '仅拥有者可设置此 Work Agent 的可见性与分享，被分享者仅能查看与执行，无法管理。',
    PRIVATE_SHARING_HINT: '如设为「私有」，需明确指定分享对象才可见。可同时设置用户与群组分享。',
    SHARE_TO_USER: '分享给用户',
    SHARE_TO_GROUP: '分享给群组',
    SEARCH_USER_PLACEHOLDER: '搜索用户或 Email...',
    SEARCH_GROUP_PLACEHOLDER: '搜索群组...',
    SHARE_USER_DESC_TEMPLATE: '被分享者可在模板选择对话框看到此模板，并以此创建 Work Agent（只读权限，不可编辑或删除模板）。',
    SHARE_USER_DESC_INSTANCE: '被分享者可查看并执行此 Work Agent（只读权限，不可编辑或删除）。',
    SHARE_GROUP_DESC: '群组成员变动即时生效，依当前群组名单解析可见性。',
    SELECT_ALL: '全选',
    SAVING: '保存中...',
    SAVED: '已保存',
    PUBLIC_WARNING_TEMPLATE: '设为公开后，全租户用户均可见并可使用，无需逐一指定分享对象。已设置的指定分享将不再影响可见性（不删除既有设置）。',
    PUBLIC_WARNING_INSTANCE: '设为公开后，全租户用户均可查看并执行此 Work Agent，无需逐一指定分享对象。已设置的指定分享将不再影响可见性（不删除既有设置）。',
    NO_EDIT_PERMISSION: '您没有编辑此 Work Agent 的权限',
    NO_DELETE_PERMISSION: '您没有删除此 Work Agent 的权限',
    NO_MANAGE_ACCESS_PERMISSION: '您没有管理访问权限的权限',
    ERROR_NO_PERMISSION: '您没有执行此操作的权限',
    ERROR_SHARE_SAVE_FAILED: '访问权设置保存失败，请稍后再试',
    ERROR_SHARE_REMOVE_FAILED: '移除分享设置失败，请稍后再试',
    ERROR_ONEDRIVE_TOKEN_EXPIRED: '来源连接已失效，请联系拥有者重新授权',
    ACCESS_REVOKED_TITLE: '无法访问此 Work Agent',
    ACCESS_REVOKED_MESSAGE: '您对此 Work Agent 的访问权限已被拥有者调整或取消。请重新整理页面以更新列表。',
    REFRESH_PAGE: '重新整理页面',
  },
  DOCUMENT_AGENT_SELECT: {
    SELECT_FOLDER: "选择资料夹",
    LINK_ACCOUNT: "连结帐号"
  },
  DOCUMENT_AGENT_PROPERTY: {
    NAME: "名称",
    TYPE: "类型",
    MODEL: "模型",
    INPUT: "输入",
    DESCRIPTION: "指示",
    COLLECTION_PROPERTIES: "集合资料栏位",
    COLLECTION_NAME_DUPLICATE: "集合表格中该名称已被使用，请修改名称",
    USER_PROMPT: "指示",
    REASONING_EFFORT: "推理投入程度",
    OPTIONS: "选项",
    READ_DOCUMENTS:"参考文件",
    CHOOSE_READ_DOCUMENTS:"请选择需参考文件",
    CHOOSE_INPUT_COLUMN:"请选择输入栏位",
    FILL_COLUMN_NAME:"请填入栏位名称",
    FILL_PROMPT:"请输入提示词",
    FILE_UPLOAD: "文件上传",
    ONEDRIVE_FILE: "OneDrive 文件",
    TEXT: "文本",
    NUMBER: "数字",
    COLLECTION: "集合数据",
    SINGLE_SELECT: "单选",
    DOCUMENT_OUTPUT: "文件输出",
    ERROR_DOCUMENT_OUTPUT_IN_COLLECTION: "文件输出类型字段不可创建在集合子表中。",
    ERROR_ONEDRIVE_IN_COLLECTION: "OneDrive 文件类型字段不可创建在集合子表中。",
    ERROR_ONEDRIVE_ONLY_ONE: "同一张表仅允许创建 1 个 OneDrive 文件类型字段。",
    LOADED_ALL: "已加载全部",
    CONFIRM_UPDATE_TO_ONEDRIVE: "此操作将会删除旧有数据，确定要更新吗？",
    ERROR_DUPLICATE_COLUMN_NAME: "同一层 Table 不可有重复名称的栏位",
    TEMPLATE: "模板",
    TEMPLATE_PLACEHOLDER_DOCX_ONLY: "仅接受 .docx 格式",
    TEMPLATE_REUPLOAD: "重新上传",
    TEMPLATE_DELETE: "删除",
    TEMPLATE_DELETE_CONFIRM: "确定要删除已上传的模板吗？",
    TEMPLATE_FORMAT_ERROR: "模板格式错误，仅接受 .docx 格式",
    COLLAPSE: "收起",
    EXPAND: "展开",
    NO_DATA: "无数据",
    COLLECTION_SUMMARY: "{count} 条集合数据",
    PYTHON_TOOL: "Python 工具",
    MODEL_LIST_NOT_CONFIGURED: "此租户的 Work Agent 模型设置尚未建立或内容不正确，请联系系统管理员。",
    VISION_MODEL: "视觉模型",
    NO_VISION_MODEL: "目前没有可用的视觉模型，请联系系统管理员。",
    MODEL_LIST_LOAD_FAILED: "无法取得模型清单，请稍后再试。",
    PYTHON_CODE: "代码",
    PYTHON_CODE_HINT: "将输出赋值给 result。输入字段可作为变量使用。",
    PYTHON_CHAR_COUNT: "目前：{count} / 5,000 字符",
    CONFIRM_LEAVE_PYTHON: "切换离开 Python 工具将丢弃当前脚本。是否继续？",
    TOOL_SELECTOR_LABEL: "工具",
    TOOL_OPTION_NONE: "（无）",
    VALIDATION_EMPTY_SCRIPT: "程式碼不可為空白。",
    VALIDATION_MISSING_RESULT: "脚本必须将值赋给 'result'。",
    VALIDATION_SYNTAX_ERROR: "第 {line} 行语法错误：{message}",
    VALIDATION_OVER_LIMIT: "脚本超过 5,000 字符限制（目前：{n} 字符）。",
    VALIDATION_SERVICE_UNAVAILABLE: "验证服务暂时不可用，请稍后再试。",
    VALIDATION_UNDECLARED_VARIABLE: "脚本中使用了未声明的变量：{vars}。若已重新命名输入字段，请同步更新脚本中对应的变量名称。",
    EXECUTION_ERROR_TIMEOUT: "执行超时。",
    EXECUTION_ERROR_NO_RESULT: "脚本未产生结果。",
    EXECUTION_ERROR_SESSION_FAILURE: "无法启动执行 Session。",
    EXECUTION_ERROR_TYPE_MISMATCH: "Result 不是有效的数字。",
    EXECUTION_ERROR_SESSION_UNAVAILABLE: "执行 Session 暂时无法使用，请稍后再试。",
    WEB_SEARCH_HINT: "Bing 搜索结果将自动注入上下文。使用 [[字段描述]] 引用输入字段值。",
    WEB_SEARCH_TOOL: "Web Search Tool",
    WEB_SEARCH_ERROR_API: "网络搜索服务无法使用，请稍后再试。",
    WEB_SEARCH_ERROR_QUOTA: "搜索服务暂时无法使用，请稍后再试。",
    WEB_SEARCH_ERROR_SAVE: "搜索结果保存失败。",
    WEB_SEARCH_ERROR_TIMEOUT: "执行超时。",
    PROVIDER_UNREACHABLE_ERROR: "AI 服务暂时无法连接，请稍后再试或联系系统管理员。",
    PROVIDER_AUTH_FAILED_ERROR: "AI 服务验证失败，请确认 API 密钥设置是否正确。",
    STRUCTURED_OUTPUT_PARSE_ERROR: "AI 输出格式解析失败，请重试。",
    DOCUMENT_OUTPUT_ERROR_SYNTAX: "模板语法错误，请检查 Word 模板中的标签格式。",
    DOCUMENT_OUTPUT_ERROR_MISMATCH: "模板与当前 Agent 数据结构不符，请确认字段名称是否正确。",
    DOCUMENT_OUTPUT_ERROR_RENDER: "文件生成失败，请确认模板格式是否正确。",
    PDF_AS_IMAGE: "以图像分析 PDF",
    PDF_AS_IMAGE_HINT: "PDF 的每一页会转换为图片交由 AI 判读，仅对 PDF 文件生效。",
    IMAGE_ERROR_PDF_PAGES_EXCEEDED: "PDF 内容超出图片数量上限 ({n}>{x})",
    IMAGE_ERROR_INPUT_IMAGES_EXCEEDED: "参考的图片数量 {n} 超出图片数量上限 {x}",
    IMAGE_ERROR_MODEL_UNSUPPORTED: "选定的模型 {x} 不支持图片输入",
    INPUT_FILE_ERROR: "输入字段「{x}」处理失败，请先修正后再执行",
    INPUT_PDF_NOT_READY: "输入字段「{x}」的 PDF 尚未按当前设置重新处理，请先执行该文件字段",
  },
  //Up Portal
  MenuBarPortal: {
    NEW_THREAD: '新增问题',
    LIBRARY: '图书馆',
    THREAD_HISTORY: '日志',
  },
  MAIN_PORTAL_VIEW: {
    INTRO: '我有什麽可以协助您?',
  },
  PORTAL: {
    SHARE: '分享',
    REFERENCE: '参考',
    ANSWER: '答案',
    KNOWLEDGE: '知识库',
    APPLY: '确认',
    Related: '相关主题',
    RelatedImages: '相关图档',
    ViewLess: '查看更少',
    ViewMore: '查看更多',
    ERROR_1: 'AI伺服器忙碌中，请稍后再试',
    ERROR_2: 'AI生成中，请稍后重新整理',
    MISS_CONTENT_TITLE: "找不到参考文件。",
    MISS_CONTENT_DETAIL: "您要查找的资源可能已被删除。",
    NO_RELATED_ANSWER: "目前没有相关信息！",
    ANSWER_INTERRUPTED: "此回答尚未完成，请点选「重新生成」再试一次。",
    HELPFUL: '有帮助',
    UNHELPFUL: '没帮助',
    COPY: '克隆',
    REWRITE: '重新生成',
    MESSAGE_DELETE: '请确定删除 ',
    DELETE_AGENT_CONFIRM: '此操作将删除 {agent}，确定要删除吗？',
    DELETE_COLUMN_CONFIRM: '此操作将删除 {column}，确定要删除吗？',
    DONT_DELETE: '不删除',
    CONFIRM_UPDATE: '确认更新',
    CONFIRM_DELETE: '确认删除',
    ERROR_3: 'Oops，遇到一些小问题，请点下方的"重新生成"按钮再试一次！',
    MY_KNOWLEDGE: "私有知识库",
    THINKING_GENERATE: '推理思考',
    NO_REFERENCE: '没有参考资料',
    MORE_RISK: "以下回复具有较高风险",
    NO_REFERENCE_MESSAGE: '本次回复未附上参考资料，AI 可能回复不准确。建议增加知识库内容，或输入更完整、明确的指令与问题描述，以提升回复品质。(若有上传档案，请加入提示词：”根据我上传的文件”，再提问。)',
    WEB_SOURCE: "资料来源：",
    ERROR_4: "連接已斷開，請重新刷新頁面。",
    DELETE_ROWS_CONFIRM_MESSAGE: "此操作将删除 {count} 笔 {tableName} 数据及子层相关记录，确定要删除吗？",
    FAVORITES: '收藏知识库',
    FAVORITE_SHORT: '收藏',
    ADD_TOOL_KNOWLEDGE: '新增工具与知识库',
  },
  TENANTCENTER: {
    TITLE: '租戶中心',
    TENANTLIST: '租户清单',
    USAGE_ANALYSIS: '数据中心',
    CREATE_TENANT: '新增租户',
    CREATE_SUPERUSER: '新增全域使用者',
    UPDATE_SUBSCRIPTION: '更新订阅到期日',
    LOGOUT: '注销',
    CREATE: '创造',
  },
  TENANTCENTER_SUMMARY: {
    MONTH_USAGE: '月用量',
    RANK_TABLE_HEADER_1: '储存体用量(G)',
    RANK_TABLE_HEADER_2: '智慧文档处理用量(页)',
    RANK_TABLE_HEADER_3: '智慧文档处理容量(页)',
    RANK_TABLE_HEADER_4: '图片储存体用量(张)',
    RANK_TABLE_HEADER_5: '图片储存体容量(张)',
    RANK_TABLE_HEADER_6: '剩余金额(USD)',
    RANK_TABLE_HEADER_7: '储值金额(USD)',
  },
  TENANTCENTER_TENANT_LIST: {
    SCHEMANAME: '资料库名称',
    TENANTNAME: '租户名称',
    DESCRIPTION: '描述',
    CREATED_ON: '创建日期',
    EXPIRATION: '订阅到期日',
    LICENSED: '授权数',
    ACTION: '操作',
  },
  ADD_TENANT: {
    TITLE: '新增租户',
    TENANTNAME: '租户名称',
    DESCRIPTION: '描述',
    LICENSED: '授权数',
    NAME_HINT: '名称不能重复，且租户建立后，名称将不能修改。',
    LICENSED_HINT: '租户建立后，可以新增的人员数量。',
    ADD_TENANT_WAIT: '租户创建作业进行中，这可能需要一段时间。您可以稍后点击「更新」以确认是否已完成建立。',
    PROCESSING: '建立中请稍后'
  },

  TENANTCENTER_USER_LIST: {
    LIST: '用户清单',
    USERNAME: '用户',
    FIRSTNAME: '用户名',
    LASTNAME: '用户姓氏',
    EMAIL: '邮箱',
    SUPERUSER: '超级用户',
    ADMIN: '管理员',
    ACTIVE: '启用',
    LOGIN_DATE: '登录日期',
    JOIN_DATE: '加入日期',
  },
  ADD_SUPERUSER: {
    TITLE: '新增全域使用者',
    TENANTNAME: '租户名称',
    SELECT_TENANT: '选择租户',
    LASTNAME: '使用者姓',
    FIRSTNAME: '使用者名',
    USERNAME: '使用者名称',
    EMAIL: '信箱',
    PASSWORD: '密码',
    PASSWORD__HINT: '密码必须包含至少 8 个字符，至少一个大写字符（A-Z），至少一个数字字符（0 ... 9），至少一个特殊字符。',
  },
  TENANT_PIPELINE: {
    CREATE: '创建',
    BUTTON: '以流程设置租户',
    TITLE: '以流程设置租户',
    STAGE_TENANT: '选择租户',
    STAGE_ADMIN: '设置系统管理员',
    STAGE_UPCHAT: '启用 UpChat',
    STAGE_PORTAL: '启用 UpGPT Portal',
    STAGE_WORK_AGENT: '启用 Work Agent',
    STAGE_UPAGENT: '启用 UpAgent',
    CURRENT_TENANT: '当前设置的租户',
    PREVIOUS: '上一步',
    NEXT: '下一步',
    UPDATE: '更新',
    FINISH: '结束',
    UPDATING: '正在更新...',
    FORM_INVALID: '请修正字段内容后再提交',
    PARTIAL_FAILED: '部分项目未完成，请查看下方信息',
    MODE_EXISTING: '选择既有租户',
    MODE_NEW: '新建租户',
    TENANT_EXISTS: '租户名称已存在',
    CREATING_TENANT: '正在建立 tenant...',
    LOADING_SEED: '正在载入基本数据...',
    SEED_FAILED: '租户已建立，但基本数据尚未载入成功。请按「创建」重试载入基本数据。',
    SEED_RETRY_HINT: '租户已建立，按「创建」将只重试载入基本数据。',
    ADMIN: '管理员',
    ADD_ADMIN: '新增管理员',
    GENERATE_PASSWORD: '生成密码',
    CREATING_ACCOUNT: '正在建立账号...',
    ADMIN_CREATED: '已建立',
    ADMIN_PARTIAL_FAILED: '{total} 位中有 {failed} 位建立失败，请修正后再按「创建」',
    NAME: '姓名',
    UPCHAT_USER: 'UpChat 账号',
    UPCHAT_ACCOUNT: 'UpChat Account',
    CREATED: '已建立',
    NOT_CREATED: '未建立',
    NO_SUPERUSER: '此租户尚无系统管理员',
    ENABLE_PORTAL_KNOWLEDGE: '启用 UpGPT Portal 知识库',
    ENABLE_IMAGE_SEARCH: '启用以图搜图',
    STORAGE_SIZE: '知识库存储上限（GB）',
    IMAGE_SEARCH_STORE: '以图搜图图片数上限（张）',
    SEARCH_SERVICE: 'Search service',
    FROM_PREFERENCE: '来自租户 {tenant} 的设置',
    UNREACHABLE: '无法连接',
    ORPHAN_INDEX: '未对应任何租户',
    PORTAL_BOT_SOURCE: 'UpGPT Portal AI Bot 复制来源租户',
    PORTAL_BOT_EXISTS: '此租户已有 UpGPT Portal AI Bot：{name}',
    NO_PORTAL_BOT_SOURCE: '没有其他租户有 UpGPT Portal AI Bot 可供复制',
    ENABLE_WORK_AGENT: '启用 Work Agent',
    MAX_THREAD: 'Work Agent multi-thread 上限',
    WORK_AGENT_DISABLE_HINT: '更新后此租户将停用 Work Agent；multi-thread 上限与模型清单会保留。',
    ENABLE_UPAGENT: '启用 UpAgent',
    ACTIVATION_CODE: '激活码',
    COPY: '复制',
    UPAGENT_DISABLE_HINT: '更新后此租户的激活码将被删除，UpAgent 无法再以该激活码激活；模型清单会保留。',
    INCLUDE_NATIVE_AOAI: '包含原生 AOAI 模型',
    DISPLAY_NAME: '显示名称',
    KEY_LOCKED: '既有模型的 key 不可修改',
    KEY_DUPLICATED: 'key 不可重复',
    COST_KEY_HINT: '不选代表此模型不计费',
    DEFAULT_MODEL: '默认模型',
    DEFAULT_MODEL_HINT: '未选择时以清单第一笔为默认',
  },
  UPDATE_SUBSCRIPTION: {
    TITLE: '更新订阅到期日',
    TENANTNAME: '租户名称',
    SELECT_TENANT: '选择租户',
    SUBSCRIPTION: '訂閱到期日',
  },
  //Other
  BUSINESS_TYPE: {
    OPPTY: "商机",
    CASE: "案件",
    COMPANY: "公司",
    CONTACT: "联络人",
    AI_NOTEBOOK: "AI 笔记本",
  },
  WIADVANCE: {
    MESSAGE_1: "请至少填入一项产品并确认必填字段。Business Type、Customer Code、金额、预估毛利额、利润%",
    MESSAGE_2: "请确认所选商机至少填入一项产品并确认必填字段。Business Type、Customer Code、金额、预估毛利额、利润%",
  },
  FLEXFIELD: {
    SELECT_TABLE: "表格名称"
  },
  ENTRAIDSYNC: {
    TITLE: "同步Entra ID用户",
    INSTRUCTION: "请选择要同步的Entra ID用户。",
    SELECTED: "已选择",
    EMAIL: "邮箱",
    FIRST_NAME: "名",
    LAST_NAME: "姓",
    SYNC: "是否已同步",
    BUSINESS_PHONES: "办公电话",
    OFFICE_LOCATION: "办公地点",
    JOB_TITLE: "职称",
    PORTAL_USER: 'Portal 使用者',
  },
  LOGIN_PAGE_SETTING: {
    TITLE: "自定义设置",
    SECTION_TITLE: "登录页设置",
    SAVE: "确认",
    SAVE_SUCCESS: "保存成功",
    SAVE_ERROR: "保存失败，请稍后再试",
    LOGO_IMAGE: "公司 Logo",
    LOGO_HINT: "最佳尺寸: 360×80px，格式: png",
    BG_IMAGE: "背景图片",
    BG_HINT: "最佳尺寸: 1440×900，格式: jpg",
    TITLE_TEXT: "标题文字",
    TITLE_TEXT_PLACEHOLDER: "欢迎回来",
    TITLE_TEXT_HINT: "字数限制为 20 个字元以内（约 10 个中文字）",
    TITLE_COLOR: "标题颜色",
    SUBTITLE_TEXT: "副标文字",
    SUBTITLE_TEXT_PLACEHOLDER: "准备开始与 UpGPT 的精彩对话？",
    SUBTITLE_TEXT_HINT: "字数限制为 50 个字元以内（约 10-25 个中文字）",
    SUBTITLE_COLOR: "副标颜色",
    LOGIN_BUTTON: "登录按钮",
    BUTTON_COLOR: "按钮颜色",
    BUTTON_TEXT_COLOR: "文字颜色",
    COLOR_UNSET: "未设置",
    LOGIN_URL_LABEL: "登录 URL",
    LOGIN_URL_DESC: "通过此 URL 进入登录页，将套用您的品牌自定义设置",
    PORTAL_URL_LABEL: "UpGPT Portal",
    CONSOLE_URL_LABEL: "UpGPT Console",
    COPY: "复制",
    COPY_SUCCESS: "已复制",
    IMG_FORMAT_ERROR_LOGO: "Logo 图片格式不符，请上传 PNG 格式",
    IMG_FORMAT_ERROR_BG: "背景图片格式不符，请上传 JPG 格式",
    IMG_SIZE_ERROR: "图片大小超过 5MB，请重新选择",
  },
  URBANRENEWAL_ADMIN: {
    SYSTEM_TITLE: "都更房车选配系统 — 后台管理",
    PG: {
      TOTAL: '共 {count} 笔',
      RPP: '每页 {n} 笔',
    },
    CURRENT_PROJECT: "当前项目",
    PROJECT_LABEL: "项目名称",
    NO_PROJECTS: "暂无项目",
    NAV_BASIC: "基本资料",
    NAV_STATISTICS: "统计资料",
    NAV_HEATMAP: "选配状况",
    NAV_SIMULATION: "模拟试算",
    NAV_MANUAL: "手动登打",
    PROJECT_SETTINGS: "项目设定",
    ADMIN_SETTINGS: "管理者设定",
    LOGOUT: "登出",
    GEAR_MENU: "设定菜单",
    LOGIN: {
      WELCOME: '欢迎回来',
      TITLE: '登入',
      ACCOUNT: '帐号',
      PASSWORD: '密码',
      SUBMIT: '登入',
      FORGOT: '忘记密码',
      ERR_REQUIRED: '请输入帐号与密码',
      ERR_INVALID: '帐号或密码错误',
      ERR_NO_ACCESS: '无后台存取权限',
      ERR_NO_TENANT: '无法识别租户，请确认登入网址',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    PROJECT: {
      TITLE: '建案设定',
      ADD: '新增建案',
      NAME: '建案名称',
      START: '选配开始日期',
      DEADLINE: '选配结束日期',
      SAVE: '储存',
      SAVED: '已储存',
      DELETE: '删除',
      EXPIRED: '已结束',
      NAME_REQUIRED: '请输入建案名称',
      DELETE_CONFIRM: '确定要删除建案「{name}」吗？此操作无法复原。',
      DELETE_HAS_DATA: '建案含关联资料，无法删除。',
      CANCEL: '取消',
      CLOSE: '关闭',
      BACK: '返回',
      SAVE_FAILED: '储存失败，请重试。',
    },
    PERIOD_LABEL: '选配期间',
    NO_PERIOD: '未设定选配期间',
    LANDOWNER: {
      TAB_LANDOWNER: '地主资料',
      TAB_HOUSING: '房屋资料',
      TAB_PARKING: '车位资料',
      WIP: '待开发',
      PRIORITY_ZONE: '优先选区',
      NAME: '所有权人',
      ACCOUNT: '帐号',
      PASSWORD: '密码',
      ADDRESS: '建物门牌',
      LAND_SHARE: '土地持份',
      PARKING_ALLOCATION: '车位分配',
      PARKING_VALUE: '车位价值(元)',
      PRE_RATIO: '更新前权值(%)',
      PRE_VALUE: '更新前价值(元)',
      SELECTABLE_VALUE: '可选配价值(元)',
      ALLOCATED_VALUE: '应分配价值(元)',
      ACTION: '操作',
      IMPORT: '导入 Excel',
      EXPORT: '导出 Excel',
      DELETE: '删除',
      DELETE_N: '删除 {count} 笔',
      REGEN_PASSWORD: '重新生成密码',
      COPY: '复制',
      COPIED: '已复制',
      DELETE_CONFIRM: '确定要删除选取的 {count} 笔地主吗？此操作无法复原。',
      DELETE_CONFIRM_ROWS: '确定要删除选取的 {count} 笔吗？此操作无法复原。',
      CANCEL: '取消',
      CLOSE: '关闭',
      CONFIRM: '确认',
      REGEN_TITLE: '新密码',
      REGEN_HINT: '请复制后告知地主（系统不会自动发送）。',
      IMPORT_ERROR_TITLE: '汇入结果',
      IMPORT_SUMMARY: '成功汇入：新增 {created} 笔、更新 {updated} 笔。以下为未汇入列：',
      IMPORT_SUCCESS: '汇入完成：新增 {created} 笔、更新 {updated} 笔，无错误。',
      COL_ROW: '行号',
      COL_REASON: '错误说明',
      IMPORT_FAILED: '汇入失败，请确认档案格式。',
      SAVE_FAILED: '储存失败，请重试。',
      TOTAL: '共 {count} 笔',
      RPP: '每页',
      NO_DATA: '无资料',
      SELECT_PROJECT: '请先选择项目',
      LOADING: '载入中...',
    },
    HOUSING: {
      PRIORITY_ZONE: '优先选区',
      CODE: '房屋编号',
      AREA: '权状面积(坪)',
      UNIT_PRICE: '单价(元/坪)',
      TOTAL_PRICE: '总价(元)',
      SALES_UNIT_PRICE: '销售单价(元)',
      SALES_TOTAL_PRICE: '销售总价(元)',
    },
    PARKING: {
      CODE: '车位编号',
      SPEC: '规格',
      TYPE: '型式',
      VALUE: '价值(元)',
    },
    STAT: {
      TAB_LANDOWNER: '地主统计',
      TAB_HOUSING: '房屋统计',
      TAB_PARKING: '车位统计',
      WIP: '待开发',
      FILTER_ZONE: '优先选区',
      FILTER_NAME: '搜索所有权人',
      FILTER_STATUS: '选配情况',
      ALL: '全部',
      COUNT: '共 {count} 组地主',
      COL_ZONE: '优先选区',
      COL_OWNER: '所有权人',
      COL_HOUSE: '选配房屋编号',
      COL_PARKING: '选配车位编号',
      COL_SELECTION_TOTAL: '选配金额合计(元)',
      COL_MAKEUP: '预估找补金额(元)',
      COL_MAKEUP_STATUS: '找补状态',
      COL_SELECTION_STATUS: '选配情况',
      COL_OVER_RATIO: '超选百分比',
      SEL_LOW: '低选',
      SEL_NORMAL: '正常',
      SEL_OVER: '超选',
      MK_REFUND: '可领回差额',
      MK_PAY: '地主应补差额',
      DASH: '—',
      EXPORT: '导出 Excel',
      NO_DATA: '无数据',
      SELECT_PROJECT: '请先选择项目',
      LOAD_FAILED: '载入失败',
      EXPORT_FAILED: '导出失败',
      SEARCH_HOUSE: '搜寻房屋编号',
      SEARCH_PARKING: '搜寻车位编号',
      FILTER_CATEGORY: '选配分类',
      CAT_NORMAL: '正常',
      CAT_NONPRIORITY: '非优先',
      CAT_OVER: '超选',
      HS_COL_ZONE: '优先选区',
      HS_COL_CODE: '房屋编号',
      HS_COL_NORMAL: '正常选配',
      HS_COL_NONPRIORITY: '非优先选配',
      HS_COL_OVER: '超选',
      PS_COL_CODE: '车位编号',
      PS_COL_NORMAL: '正常选配',
      PS_COL_OVER: '超选',
      COL_GROUP_COUNT: '组数统计',
      UNIT_GROUP: '组',
      COUNT_ROWS: '共 {count} 笔',
    },
    HEATMAP: {
      TAB_HOUSING: '房屋选配',
      TAB_PARKING: '车位选配',
      WIP: '待开发',
      EXPORT_PDF: '汇出 PDF',
      EXPORT_EXCEL: '导出 Excel',
      EXPORT_FAILED: '导出失败，请稍后再试。',
      PDF_TITLE: '房屋选配热度图',
      PDF_FAILED: 'PDF 汇出失败，请允许弹出视窗后重试',
      TT_UNIT_CODE: '单元编号',
      TT_AREA: '坪数',
      TT_UNIT_PRICE: '单价（元/坪）',
      TT_TOTAL_PRICE: '总价（元）',
      TT_SPEC: '规格',
      TT_TYPE: '型式',
      TT_VALUE: '价值',
      TT_COUNT: '已选配组数',
      TT_OWNERS: '地主',
      TT_NORMAL: '正常',
      TT_NONPRIORITY: '非优先',
      TT_OVER: '超选',
      U_PING: '坪',
      U_YUAN: '元',
      UNIT_GROUP: '组',
      LGD_NONE: '0组选择',
      LGD_ONE: '1 组选择',
      LGD_MULTI: '多组选择',
      LOAD_FAILED: '载入失败',
      NO_DATA: '无资料',
      SELECT_PROJECT: '请先选择建案',
      PDF_TITLE_PARKING: '车位选配热度图',
      TT_CODE: '车位编号',
    },
    SIM: {
      OWNER_SECTION: '地主资料',
      SELECT_SECTION: '房车选配',
      RESULT_BASIC: '基本资料',
      RESULT_SELECTION: '选配试算',
      OWNER_NAME: '地主姓名',
      HOUSE_CODE: '房屋编号',
      PARKING_CODE: '车位编号',
      ALLOCATED: '应分配价值',
      SELECTABLE: '可选配价值',
      SELECTION_TOTAL: '选配价值总计',
      SELECTION_RATIO: '选配比例',
      MAKEUP: '预估找补金额',
      ADD_OWNER: '新增地主',
      ADD_HOUSE: '新增房屋',
      ADD_PARKING: '新增车位',
      CALC: '试算',
      RESET: '重新输入',
      RESULT_TITLE: '试算结果',
      REFUND: '可领回差额',
      PAY: '地主应补差额',
      CANNOT_CALC: '无法计算',
      CLEAR_ALL: '全部清除',
      NAME_HEADER: '姓名',
      COL_UNIT_CODE: '选配单元编号',
      COL_DUP_GROUP: '重复组数',
      HOUSE_ITEM: '房屋',
      PARK_ITEM: '车位',
      FORMULA_CASE_A: '加总 ≤ 应分配×110%（{threshold}元）',
      FORMULA_CASE_B: '加总 > 应分配×110%（{threshold}元）',
      BALANCE_DEFICIT: '应补差额',
      PH_OWNER: '选择地主',
      PH_HOUSE: '选择房屋',
      PH_PARKING: '选择车位',
      SEARCH_PH: '搜索…',
      NO_RESULT: '无符合结果',
      OWNER_ITEM: '地主',
      GROUP_UNIT: '组',
      LOAD_FAILED: '载入失败',
      SELECT_PROJECT: '请先选择建案',
      HINT_CALC: '请于左侧选择地主与房屋／车位后点击「试算」',
    },
    MANUAL: {
      OWNER: '所有权人',
      HOUSE: '选配房屋',
      PARKING: '选配车位',
      GRP_COL: '组别',
      SUB_OWNER: '人',
      SUB_HOUSE: '选房',
      SUB_PARK: '选车',
      DELETE_COL: '删除此栏',
      ACTION: '操作',
      SORT_LABEL: '排序',
      SORT_NONE: '不排序',
      SORT_NAME: '依所有权人',
      SORT_ZONE: '依优先选区',
      IMPORT: '导入 Excel',
      EXPORT: '导出 Excel',
      SAVE: '保存',
      ADD_ROW: '新增行',
      ADD_COL: '＋ {name}栏',
      DELETE: '删除',
      CHANGELOG: '修改记录',
      CHANGELOG_EMPTY: '暂无修改记录',
      CLOSE: '关闭',
      OP_ADD: '新增',
      OP_DELETE: '删除',
      SAVE_SUCCESS: '保存成功',
      SAVE_WARN: '保存成功，但有 {count} 笔编号不存在已略过',
      SAVE_FAILED: '保存失败，请重试。',
      IMPORT_FAILED: '导入失败，请确认文件格式。',
      EXPORT_FAILED: '导出失败，请稍后再试。',
      IMPORT_ERROR_TITLE: '导入失败',
      IMPORT_WARN_TITLE: '导入完成（部分略过）',
      IMPORT_WARN_INTRO: '导入完成，但以下项目无法辨识、已略过(可于画面用下拉选取补上):',
      NO_DATA: '暂无数据，请新增行或导入',
      SELECT_PROJECT: '请先选择建案',
      LOAD_FAILED: '加载失败',
    },
    BRANDING_TITLE: '品牌 Logo',
    UPLOAD_LOGO: '上传 Logo',
    REMOVE_LOGO: '移除 Logo',
    LOGO_UPLOADED: 'Logo 已更新',
    LOGO_REMOVED: 'Logo 已移除',
    LOGO_UPLOAD_FAILED: 'Logo 上传失败，请重试',
    LOGO_INVALID_TYPE: '仅能上传图片档（png / jpg / gif / webp 等）',
    LOGO_HINT: '建议上传透明背景 PNG',
    AI_SUPPORT: {
      TITLE: 'AI 客服设定',
      ENABLE: '启用 AI 客服',
      URL: '服务网址',
      URL_PH: '例：https://chat.upday.ai',
      TOKEN: 'Website Token',
      TOKEN_PH: '贴上 UpChat 网页聊天的 websiteToken',
      SAVE: '储存',
      SAVED: '已储存',
      SAVE_FAILED: '储存失败，请重试',
    },
    ADMINS: {
      TITLE: '管理者设置',
      ADD: '新增管理者',
      COL_EMAIL: 'Email',
      COL_LAST_NAME: '姓',
      COL_FIRST_NAME: '名',
      COL_STATUS: '状态',
      COL_LAST_LOGIN: '最后登录',
      STATUS_ACTIVE: '启用',
      STATUS_INACTIVE: '已停用',
      SAVE: '保存',
      DELETE: '停用',
      REACTIVATE: '重新启用',
      DELETE_CONFIRM: '确定停用管理者「{name}」？其后台登录将被停用。',
      CREATED: '已创建管理者并发送邀请邮件',
      REACTIVATED: '已重新启用管理者',
      SAVED: '已保存',
      EMAIL_REQUIRED: '请输入有效 Email',
      EMAIL_DUP: '此 Email 已是管理者，若已停用请改用重新启用',
      SAVE_FAILED: '操作失败，请重试',
      LOAD_FAILED: '加载失败',
      CANCEL: '取消',
      CLOSE: '关闭',
      CONFIRM: '确认',
      NO_DATA: '暂无管理者',
      EDIT: '编辑',
      BACK: '返回',
      ACCOUNT: '账号',
      PH_LAST: '输入姓氏',
      PH_FIRST: '输入名字',
      PH_EMAIL: 'name@company.com',
    },
  },
  URBANRENEWAL_SELECT: {
    LOGIN: {
      WELCOME: '都更房车选配系统',
      SYS_DESC: '请以配发之账号登录，进行房屋与车位选配试算。',
      TITLE: '登录',
      ACCOUNT: '账号',
      PASSWORD: '密码',
      SUBMIT: '登录',
      FORGOT: '忘记密码',
      ERR_REQUIRED: '请输入账号与密码',
      ERR_INVALID: '账号或密码错误',
      ERR_NO_TENANT: '无法识别租户，请确认登录网址',
      COPYRIGHT: 'ART Solutions All Rights Reserved.',
    },
    FORGOT: {
      TITLE: '忘记密码',
      DESC: '请输入您的账号（Email），我们将寄送密码重设链接。',
      ACCOUNT: '账号（Email）',
      SUBMIT: '寄送重设链接',
      DONE: '若该账号存在，密码重设链接已寄至您的邮箱。',
      BACK_LOGIN: '返回登录',
      ERR_REQUIRED: '请输入账号',
    },
    RESET: {
      TITLE: '重设密码',
      NEW_PWD: '新密码',
      CONFIRM_PWD: '确认新密码',
      SUBMIT: '确认重设',
      SUCCESS: '密码已重设，请使用新密码登录。',
      ERR_REQUIRED: '请输入新密码',
      ERR_MISMATCH: '两次密码输入不一致',
      ERR_INVALID: '链接无效或已逾期，请重新申请。',
      BACK_LOGIN: '返回登录',
    },
    LAYOUT: {
      SYSTEM_TITLE: '都更房车选配系统',
      LOGOUT: '登出',
    },
    STATUS: {
      DRAFT: '选配试算中',
      SUBMITTED: '已保存',
      LOCKED: '截止锁定',
    },
    PERIOD_LABEL: '选配期间',
    LAST_UPDATED: '最后更新时间',
    STATS_UPDATED: '本统计结果最后更新时间',
    PANEL: {
      INTRO_LINE1: '请于 {deadline} 前完成房屋车位选配资料填写。',
      INTRO_LINE2: '截止日期前，资料可随时修改；一旦逾期，将无法再做任何变更。',
      BASIC_INFO: '基本资料',
      OWNER_LABEL: '地主{no}：',
      OWNER: '地主',
      ALLOCATED: '应分配价值：',
      SELECTABLE: '可选配价值：',
      CURRENCY_UNIT: '元',
      SELECTION_LIST: '选配试算',
      MOBILE_VIEW_GRID: '当前选配登记',
      MOBILE_BACK: '返回试算表',
      HOUSE: '房屋选配',
      PARKING: '车位选配',
      AREA_PING: '坪数',
      UNIT_PRICE: '单价(元/坪)',
      TOTAL_PRICE: '总价(元)',
      SPEC: '规格',
      VALUE: '价值(元)',
      SELECTED_GROUPS: '已选 {count} 组',
      COL_UNIT_CODE: '楼层编号',
      COL_GROUP_COUNT: '重复组数',
      HOUSE_ROW: '房屋{no}：',
      PARKING_ROW: '车位{no}：',
      ADD_HOUSE: '新增房屋',
      ADD_PARKING: '新增车位',
      SEARCH: '搜索…',
      NO_OPTIONS: '无可选项目',
      UNIT_PH_HOUSE: '选择房屋编号',
      UNIT_PH_PARK: '选择车位编号',
      SELECT_TOTAL: '选配价值总计：',
      MAKEUP_TITLE: '找补试算',
      MAKEUP_REFUND: '可领回差额：',
      MAKEUP_PAY: '地主应补差额：',
      MAKEUP_NONE: '找补金额：',
      AMOUNT_NOTE: '※上述金额仅供参考。实际依权利变换核定及最终选配结果为准。',
      DISCLAIMER: '本表仅依据目前已缴交之「更新后分配位置申请书」及「合并分配协议书」纸本正本进行初步统计，并非最终选定结果。最终房车选配结果，将以公开抽签会议公布的选配及抽签结果为准。',
      CLEAR_ALL: '全部清除',
      EXPORT: '导出 Excel',
      SAVE: '保存下载',
      REMOVE: '移除',
      SAVE_SUCCESS: '已保存本次选配结果，并完成图档下载。',
      SAVE_FAIL: '保存失败',
      EXPORT_FAIL: '导出失败',
      EXPORT_NEED_SAVE: '请先保存后再导出',
      EXPORT_DIRTY: '有未保存的变更，请先保存后再导出',
      EXPORT_FILENAME: '选配试算.xlsx',
    },
    GRID: {
      UNIT_GROUP: '组',
      LGD_NONE: '0组选择',
      LGD_ONE: '1组选择',
      LGD_MULTI: '多组选择',
      LGD_NONPRIORITY: '非优先区',
      OVER_LIMIT_WARN: '目前台端所选配的房车总价值已超过应分配价值之 110%，请重新选配。',
      NO_DATA: '尚无资料',
    },
    UNIT: {
      AREA_PING: '坪数',
      UNIT_PRICE: '单价(元/坪)',
      TOTAL_PRICE: '总价(元)',
      SPEC: '规格',
      VALUE: '价值(元)',
      SELECTED_GROUPS: '已选配组数',
      LINE_AREA: '坪数：{v}坪',
      LINE_UNIT_PRICE: '单价（元/坪）：{v}元',
      LINE_TOTAL_PRICE: '总价（元）：{v}元',
      LINE_SPEC: '规格：{v}',
      LINE_GROUPS: '已选配组数：{v}组',
      ADD_SELECTION: '新增选配',
      ALREADY_ADDED: '已选配此单元',
      CANCEL_SELECTION: '取消此选配',
      CLOSE: '关闭',
      NONPRIORITY_WARN: '提醒：台端本次选配的房屋单元依选配原则非属台端之优先选配区，若选配期间有其他优先选配区之所有权人亦申请该房屋单元，将可能无法获配，建请台端调整，敬请见谅！',
      NONPRIORITY_HINT: '该单元非贵住户优先选区，若与优先选区地主选配重复时，将无法以抽签方式进行选配。',
    },
    OVER: {
      TITLE: '超出可选配上限',
      CONFIRM: '确认',
    },
    DIALOG: {
      INTRO_TITLE: '选配试算提醒',
      INTRO_PERIOD_LABEL: '目前开放选配试算期间：',
      INTRO_PERIOD_RANGE: '自 {start} 至 {end} 止',
      INTRO_BODY: '本系统之房屋车位选配与找补金额仅供试算参考，请台端于选配期间内提交「更新后分配位置申请书」及「合并分配协议书」等纸本正本予实施者，以确保您的权益。',
      INTRO_OK: '我知道了',
      GRID_NOTICE: '本图表仅显示已缴交「更新后分配位置申请书」及「合并分配协议书」之纸本登记统计，本次台端所选配试算之结果不计入统计，仅供参考。',
      GRID_NEXT: '下一步',
      LEGEND_TITLE: '选配图例说明',
      LEGEND_ENTER: '进入选配',
      NONPRIORITY_TITLE: '非优先选配区提醒',
      NONPRIORITY_CONFIRM: '确认',
      NONPRIORITY_RESELECT: '重选',
      SAVE_TITLE: '确认保存',
      SAVE_BODY: '本次房车选配仅供参考，不计入正式选配统计。请台端于选配期间内提交「更新后分配位置申请书」及「合并分配协议书」等纸本正本予实施者，以确保您的权益。',
      SAVE_CONFIRM: '确定',
      SAVE_CANCEL: '返回上一步',
      RESULT_TITLE: '本次选配结果',
      RESULT_TIME: '产出时间：{t}',
      RESULT_OWNER: '地主',
      RESULT_HOUSE: '房屋',
      RESULT_PARK: '车位',
      RESULT_EMPTY: '尚未选配任何单元',
    },
    CHAT: {
      TITLE: 'AI 助理',
      COMING_SOON: 'AI 助理即将推出',
    },
  },
  LICENSE_WARNING: {
    EXPIRING_SOON: '您的授权将于 {date} 到期，请联系我们的销售人员办理续约。',
    EXPIRED_GRACE: '您的授权已于 {date} 到期，请尽快联系我们的销售人员办理续约。服务将于 {stopDate} 停止。',
    SUSPENDED: '您的授权已于 {date} 到期，请联系我们的销售人员办理续约以继续使用。',
    // 佔位文案：正式文案待需求方提供
    INVALID: '授权信息有问题，请联系我们的销售人员。',
    PREFIX_SUSPENDED: '服务已停止',
    PREFIX_INVALID: '授权无效',
  },
}
